<script setup>
import moment from "moment";
moment.locale("id");
</script>
<template>
  <DefaultLayout>
    <v-row class="mx-5 my-5">
      <v-col cols="12">
        <div
          class="w-100 border border-1 pt-2 shadow-sm"
          style="
            min-height: 5vh;
            background-color: #f8d7da;
            border-radius: 1rem;
          "
        >
          <div style="color: #28293d" class="px-3 pb-2">
            <button @click="$router.back()" class="btn">
              <font-awesome-icon
                icon="fa-solid fa-arrow-left"
                style="color: #28293d"
              />
            </button>
            {{
              $router.currentRoute.value.path.startsWith(
                "/verifikasi-data-imkp",
              )
                ? "Verifikasi Data Pengajuan IMKP"
                : "Amandemen Data IMKP"
            }}
          </div>
          <div
            class="bg-white w-100 border border-1 shadow-sm p-2 rounded-4"
            style="min-height: 60vh"
          >
            <div
              class="d-flex justify-content-between px-4 pt-4 align-items-end position-relative"
            >
              <div class="d-flex align-items-end">
                <img
                  src="../../assets/images/borneo-indobara-icon.png"
                  alt="logo"
                  style="width: 4rem; height: auto"
                  loading="lazy"
                />
                <h6 class="fw-bold w-100 m-0">PT BORNEO INDOBARA</h6>
              </div>
              <h6 class="fw-bold text-end text-nowrap m-0">
                BIB-HSE-PPO-F-071-01
              </h6>
              <button
                class="position-absolute btn btn-sm btn-danger top-0 w-25 fw-bold"
                style="right: 1.5rem"
                v-if="
                  $router.currentRoute.value.path.startsWith(
                    '/amandemen-data-imkp',
                  )
                "
                @click="getHistory(true)"
              >
                History Amandemen
              </button>
            </div>
            <div class="container p-4">
              <h1 class="text-center mb-3 font-inter font-bold text-3xl">
                IZIN MELAKSANAKAN KEGIATAN PROYEK
              </h1>
              <p
                class="text-center fs-8 mb-3"
                style="font-family: 'Inter-Regular'"
              >
                Sebagai persyaratan untuk melaksanakan kegiatan proyek di dalam
                area kerja PT Borneo Indobara
              </p>

              <div class="rounded shadow-sm mb-4">
                <table class="table table-striped w-100 rounded mb-0">
                  <thead class="table-danger">
                    <tr>
                      <td colspan="4">
                        <p class="fs-7 fw-bold m-0 ms-2">A. DETAIL IZIN</p>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <TableComponent
                      :data="detailIzin"
                      :column="2"
                      :subTitle="false"
                    />
                  </tbody>
                  <thead class="table-danger">
                    <tr>
                      <td colspan="4">
                        <p class="fs-7 fw-bold m-0 ms-2">B. DETAIL PEKERJAAN</p>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colspan="4">
                        <p class="fs-8 ms-2 m-0">Uraian Pekerjaan</p>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="4" class="no-style">
                        <div
                          class="ms-4 w-100 fs-8"
                          style="
                            white-space: pre-line;
                            word-break: break-word;
                            overflow-wrap: break-word;
                          "
                        >
                          {{ imkp?.deskripsiPekerjaan }}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <thead class="table-danger">
                    <tr>
                      <td colspan="4">
                        <p class="fs-7 fw-bold m-0 ms-2">
                          C. PENCEGAHAN / PERSYARATAN KHUSUS
                        </p>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colspan="4">
                        <div class="row fw-bold ms-2 fs-8">
                          <div class="col-7">Daftar Periksa</div>
                          <div class="col-1">Is Verified</div>
                          <div class="col-4">
                            Catatan
                            <template
                              v-if="status === statusIMKPEnum.UNDER_REVIEW"
                            >
                              <br />
                              <span
                                class="text-xs font-normal italic text-red-700"
                              >
                                *Ketika dokumen tidak sesuai maka catatan wajib
                                diisi.
                              </span>
                            </template>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <template
                      v-for="item in formValues.persyaratanKhusus.filter(
                        (data) => data.file.length >= 1,
                      )"
                      :key="item.key"
                    >
                      <tr>
                        <td colspan="4" class="no-style">
                          <p class="fs-8 ms-2 m-0">
                            {{ item.name }}
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="4" class="no-style">
                          <div class="row">
                            <div class="col-7">
                              <ul>
                                <li
                                  v-for="(file, i) in item.file"
                                  :key="i"
                                  class="fs-9"
                                >
                                  <div
                                    class="d-flex flex-wrap align-items-center gap-3"
                                  >
                                    <span>
                                      File {{ item.name }}_{{ i + 1 }}.pdf
                                      <font-awesome-icon
                                        class="text-danger cursor-pointer mx-2"
                                        icon="fa-solid fa-eye"
                                        @click="showFile(file)"
                                      />
                                      <font-awesome-icon
                                        class="text-danger cursor-pointer"
                                        icon="fa-solid fa-download"
                                        @click="downloadFile(file)"
                                      />
                                    </span>
                                  </div>
                                </li>
                              </ul>
                            </div>
                            <div class="col-1">
                              <div class="d-flex justify-content-center">
                                <div class="form-check">
                                  <input
                                    type="checkbox"
                                    class="form-check-input"
                                    style="
                                      border-radius: 10px;
                                      border-color: black;
                                    "
                                    v-model="item.isVerified"
                                    :disabled="
                                      status !== statusIMKPEnum.UNDER_REVIEW
                                    "
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="col-4">
                              <textarea
                                v-if="status === statusIMKPEnum.UNDER_REVIEW"
                                class="form-control fs-8"
                                style="white-space: pre-line"
                                :placeholder="
                                  !item.isVerified ? 'Masukkan catatan' : ''
                                "
                                v-model="item.note"
                                :class="{
                                  'is-invalid':
                                    formValidasi?.persyaratanKhusus?.find(
                                      (data) => data.key === item.key,
                                    ).required,
                                }"
                              ></textarea>
                              <p
                                v-else
                                class="fs-9 m-0 ms-2 fw-normal"
                                style="white-space: pre-line"
                              >
                                {{ item.note }}
                              </p>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </template>
                    <tr>
                      <td colspan="4">
                        <p class="fs-8 ms-2 m-0">Tindakan Pencegahan Lainnya</p>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="4" class="no-style">
                        <div
                          class="ms-4 w-100 fs-8"
                          style="
                            white-space: pre-line;
                            word-break: break-word;
                            overflow-wrap: break-word;
                          "
                        >
                          {{ imkp?.tindakPencegahan }}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <thead class="table-danger">
                    <tr>
                      <td colspan="4">
                        <p class="fs-7 fw-bold m-0 ms-2">
                          D. PENGESAHAN UNTUK IZIN MELAKSANAKAN KEGIATAN PROYEK
                        </p>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colspan="4">
                        <p class="fs-8 fw-bold ms-2 m-0">
                          Penanggung Jawab Operasional (PJO)
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td style="background: #f8e3e5">
                        <p class="fs-8 fw-bold m-0 text-center">Nama</p>
                      </td>
                      <td style="background: #f8e3e5">
                        <p class="fs-8 fw-bold m-0 text-center">Jabatan</p>
                      </td>
                      <td style="background: #f8e3e5">
                        <p class="fs-8 fw-bold m-0 text-center">Tanggal</p>
                      </td>
                      <td style="background: #f8e3e5">
                        <p class="fs-8 fw-bold m-0 text-center">Tanda Tangan</p>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-center align-bottom no-style">
                        <p class="fs-7 m-0 ms-2">
                          {{ pjo.name }}
                        </p>
                      </td>
                      <td class="text-center align-bottom">
                        <p class="fs-7 m-0 ms-2">
                          {{ pjo.jabatan }}
                        </p>
                      </td>
                      <td class="text-center align-bottom">
                        <p class="fs-7 m-0 ms-2">
                          {{
                            imkp?.tglTtdPjo
                              ? moment(new Date(imkp?.tglTtdPjo)).format(
                                  "DD MMMM YYYY",
                                )
                              : "-"
                          }}
                        </p>
                      </td>
                      <td>
                        <div
                          class="d-flex justify-content-center align-items-center"
                        >
                          <img
                            :src="ttdPjoFile"
                            alt="ttd-pjo"
                            style="height: 5rem; mix-blend-mode: multiply"
                            class="text-center"
                            :class="{
                              'd-none': !ttdPjoFile,
                            }"
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="4">
                        <p class="fs-8 fw-bold ms-2 m-0">Dept Head Kustodian</p>
                      </td>
                    </tr>
                    <tr>
                      <td style="background: #f8e3e5">
                        <p class="fs-8 fw-bold m-0 text-center">Nama</p>
                      </td>
                      <td style="background: #f8e3e5">
                        <p class="fs-8 fw-bold m-0 text-center">Jabatan</p>
                      </td>
                      <td style="background: #f8e3e5">
                        <p class="fs-8 fw-bold m-0 text-center">Tanggal</p>
                      </td>
                      <td style="background: #f8e3e5">
                        <p class="fs-8 fw-bold m-0 text-center">Tanda Tangan</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        class="text-center align-bottom no-style"
                        style="height: 7rem"
                      >
                        <v-autocomplete
                          v-if="status === statusIMKPEnum.UNDER_REVIEW"
                          variant="outlined"
                          density="compact"
                          hide-details
                          :items="
                            optDeptHeadKustodian?.map((item) => ({
                              ...item,
                              title: `${item.name} ${item.email} ${item.contact}`,
                              value: item,
                            }))
                          "
                          item-title="title"
                          item-value="value"
                          color="#475569"
                          return-object
                          v-model="formValues.deptHeadKustodian"
                          @input="
                            getDeptHeadKustodian($event.target.value, index)
                          "
                          :error="formValidasi.deptHeadKustodian"
                        ></v-autocomplete>
                        <p v-else class="fs-7 m-0 ms-2">
                          {{ formValues.deptHeadKustodian?.name }}
                        </p>
                      </td>
                      <td class="text-center align-bottom">
                        <p class="fs-7 m-0 ms-2">
                          {{ formValues.deptHeadKustodian?.jabatan }}
                        </p>
                      </td>
                      <td class="text-center align-bottom">
                        <p class="fs-7 m-0 ms-2">
                          {{
                            formValues.deptHeadKustodian?.tanggal
                              ? moment(
                                  new Date(
                                    formValues.deptHeadKustodian?.tanggal,
                                  ),
                                ).format("DD MMMM YYYY")
                              : moment(new Date()).format("DD MMMM YYYY")
                          }}
                        </p>
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td colspan="4">
                        <p class="fs-8 ms-2 m-0">Catatan</p>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="4" class="no-style">
                        <div
                          class="ms-4 w-100 fs-8"
                          style="white-space: pre-line"
                        >
                          {{ imkp?.catatanPenutupan }}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <thead class="table-danger">
                    <tr>
                      <td colspan="4">
                        <p class="fs-7 fw-bold m-0 ms-2">
                          E. PENGAWASAN & PENANGGUNG JAWAB KEGIATAN PROYEK
                        </p>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <TableComponent
                      :data="informasiProyek"
                      :column="2"
                      :subTitle="true"
                      title="Informasi Proyek"
                    />
                    <TableComponent
                      :data="kontraktorPelaksana"
                      :column="4"
                      :subTitle="true"
                      title="Kontraktor Pelaksana"
                      name="Nama"
                      email="Email"
                      phone="Nomor Telepon (WA)"
                    />
                  </tbody>
                </table>
                <table class="table table-striped w-100 rounded">
                  <tbody>
                    <tr></tr>
                    <tr>
                      <td style="background: #f8e3e5" class="w-1/4">
                        <p class="fs-8 fw-bold ms-2 m-0">Kustodian</p>
                      </td>
                      <td style="background: #f8e3e5" class="w-[18.75%]">
                        <p class="fs-8 fw-bold m-0">Nama</p>
                      </td>
                      <td style="background: #f8e3e5" class="w-[18.75%]">
                        <p class="fs-8 fw-bold m-0">Departemen</p>
                      </td>
                      <td style="background: #f8e3e5" class="w-[18.75%]">
                        <p class="fs-8 fw-bold m-0">Email</p>
                      </td>
                      <td style="background: #f8e3e5" class="w-[18.75%]">
                        <p class="fs-8 fw-bold m-0">Nomor Telepon (WA)</p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p class="fs-8 ms-2 m-0">Nama Departemen Kustodian</p>
                      </td>
                      <td colspan="4">
                        <div
                          class="d-flex gap-2"
                          v-if="
                            Array.isArray(
                              formValues.kustodian.namaDepartemen,
                            ) && status === statusIMKPEnum.UNDER_REVIEW
                          "
                        >
                          <div class="d-flex flex-column gap-2 w-100">
                            <div
                              v-for="(_, index) in formValues.kustodian
                                .namaDepartemen"
                              :key="index"
                            >
                              <div class="d-flex gap-2">
                                <input
                                  type="text"
                                  class="form-control fs-8"
                                  v-model="
                                    formValues.kustodian.namaDepartemen[index]
                                  "
                                  :class="{
                                    'is-invalid':
                                      formValidasi.namaDepartemen[index],
                                  }"
                                />
                                <font-awesome-icon
                                  v-if="index === 0"
                                  @click="addRow('namaDepartemen')"
                                  icon="fa-solid fa-circle-plus"
                                  style="
                                    color: #0d6efd;
                                    cursor: pointer;
                                    margin-top: 0.5rem;
                                  "
                                />
                                <font-awesome-icon
                                  v-else
                                  @click="deleteRow('namaDepartemen', index)"
                                  icon="fa-solid fa-trash"
                                  style="
                                    color: #dc3545;
                                    cursor: pointer;
                                    margin-top: 0.5rem;
                                  "
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="d-flex flex-column gap-2"
                          v-else
                          v-for="(item, index) in formValues.kustodian
                            .namaDepartemen"
                          :key="index"
                        >
                          <p class="fs-8 m-0 mb-1 mt-1">
                            {{ item }}
                          </p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p class="fs-8 ms-2 m-0">Kepala Departemen Kustodian</p>
                      </td>
                      <td class="w-[18.75%]">
                        <div
                          class="d-flex gap-2"
                          v-if="
                            Array.isArray(
                              formValues.kustodian.kepalaDepartemenData,
                            ) && status === statusIMKPEnum.UNDER_REVIEW
                          "
                        >
                          <div class="d-flex flex-column gap-2 w-100">
                            <div
                              v-for="(_, index) in formValues.kustodian
                                .kepalaDepartemenData"
                              :key="index"
                            >
                              <v-autocomplete
                                variant="outlined"
                                density="compact"
                                hide-details
                                :items="
                                  optKepalaDepartemen[index]?.map((item) => ({
                                    ...item,
                                    title: `${item.name} ${item.email} ${item.contact}`,
                                    value: item,
                                  }))
                                "
                                item-title="title"
                                item-value="value"
                                color="#475569"
                                return-object
                                v-model="
                                  formValues.kustodian.kepalaDepartemen[index]
                                "
                                @input="
                                  getKepalaDepartemen(
                                    $event.target.value,
                                    index,
                                  )
                                "
                                @update:modelValue="
                                  setInput(
                                    formValues.kustodian.kepalaDepartemen[
                                      index
                                    ],
                                    'kepalaDepartemen',
                                    index,
                                  )
                                "
                                :error="
                                  formValidasi.kepalaDepartemenKustodian[index]
                                    .name
                                "
                              ></v-autocomplete>
                            </div>
                          </div>
                        </div>
                        <div
                          class="d-flex flex-column gap-2"
                          v-else
                          v-for="(item, index) in formValues.kustodian
                            .kepalaDepartemenData"
                          :key="index"
                        >
                          <p class="fs-8 m-0 mb-1 mt-1">
                            {{ item.name }}
                          </p>
                        </div>
                      </td>
                      <td class="w-[18.75%]">
                        <div
                          class="d-flex flex-column gap-2"
                          v-for="(item, index) in formValues.kustodian
                            .kepalaDepartemenData"
                          :key="index"
                        >
                          <p class="fs-8 m-0 mb-1 mt-1">
                            {{ item.department }}
                          </p>
                        </div>
                      </td>
                      <td class="w-[18.75%]">
                        <div
                          class="d-flex flex-column gap-2"
                          v-if="
                            Array.isArray(
                              formValues.kustodian.kepalaDepartemenData,
                            ) && status === statusIMKPEnum.UNDER_REVIEW
                          "
                        >
                          <input
                            v-for="(item, index) in formValues.kustodian
                              .kepalaDepartemenData"
                            :key="index"
                            type="text"
                            class="form-control fs-8"
                            :class="{
                              'is-invalid':
                                formValidasi.kepalaDepartemenKustodian[index]
                                  .email,
                            }"
                            v-model="item.email"
                          />
                        </div>
                        <div
                          class="d-flex flex-column gap-2"
                          v-else
                          v-for="(item, index) in formValues.kustodian
                            .kepalaDepartemenData"
                          :key="index"
                        >
                          <p class="fs-8 m-0 mb-1 mt-1">
                            {{ item.email }}
                          </p>
                        </div>
                      </td>
                      <td class="w-[18.75%]">
                        <div
                          class="d-flex gap-2"
                          v-if="
                            Array.isArray(
                              formValues.kustodian.kepalaDepartemenData,
                            ) && status === statusIMKPEnum.UNDER_REVIEW
                          "
                        >
                          <div class="d-flex flex-column gap-2 w-100">
                            <div
                              v-for="(item, index) in formValues.kustodian
                                .kepalaDepartemenData"
                              :key="index"
                            >
                              <div class="d-flex gap-2">
                                <input
                                  type="text"
                                  class="form-control fs-8"
                                  v-model="item.contact"
                                  :class="{
                                    'is-invalid':
                                      formValidasi.kepalaDepartemenKustodian[
                                        index
                                      ].contact,
                                  }"
                                />
                                <font-awesome-icon
                                  v-if="index === 0"
                                  @click="addRow('kepalaDepartemenKustodian')"
                                  icon="fa-solid fa-circle-plus"
                                  style="
                                    color: #0d6efd;
                                    cursor: pointer;
                                    margin-top: 0.5rem;
                                  "
                                />
                                <font-awesome-icon
                                  v-else
                                  @click="
                                    deleteRow(
                                      'kepalaDepartemenKustodian',
                                      index,
                                    )
                                  "
                                  icon="fa-solid fa-trash"
                                  style="
                                    color: #dc3545;
                                    cursor: pointer;
                                    margin-top: 0.5rem;
                                  "
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="d-flex flex-column gap-2"
                          v-else
                          v-for="(item, index) in formValues.kustodian
                            .kepalaDepartemenData"
                          :key="index"
                        >
                          <p class="fs-8 m-0 mb-1 mt-1">
                            {{ item.contact }}
                          </p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p class="fs-8 ms-2 m-0">Pengawas Operasional</p>
                      </td>
                      <td class="w-[18.75%]">
                        <div
                          class="d-flex gap-2"
                          v-if="
                            Array.isArray(
                              formValues.kustodian.pengawasOperasionalData,
                            ) && status === statusIMKPEnum.UNDER_REVIEW
                          "
                        >
                          <div class="d-flex flex-column gap-2 w-100">
                            <div
                              v-for="(_, index) in formValues.kustodian
                                .pengawasOperasionalData"
                              :key="index"
                            >
                              <v-autocomplete
                                variant="outlined"
                                density="compact"
                                hide-details
                                :items="
                                  optPengawasOperasional[index]?.map(
                                    (item) => ({
                                      ...item,
                                      title: `${item.name} ${item.email} ${item.contact}`,
                                      value: item,
                                    }),
                                  )
                                "
                                item-title="title"
                                item-value="value"
                                color="#475569"
                                return-object
                                v-model="
                                  formValues.kustodian.pengawasOperasional[
                                    index
                                  ]
                                "
                                @input="
                                  getPengawasOperasional(
                                    $event.target.value,
                                    index,
                                  )
                                "
                                @update:modelValue="
                                  setInput(
                                    formValues.kustodian.pengawasOperasional[
                                      index
                                    ],
                                    'pengawasOperasional',
                                    index,
                                  )
                                "
                                :error="
                                  formValidasi.pengawasOperasional[index].name
                                "
                              ></v-autocomplete>
                            </div>
                          </div>
                        </div>
                        <div
                          class="d-flex flex-column gap-2"
                          v-else
                          v-for="(item, index) in formValues.kustodian
                            .pengawasOperasionalData"
                          :key="index"
                        >
                          <p class="fs-8 m-0 mb-1 mt-1">
                            {{ item.name }}
                          </p>
                        </div>
                      </td>
                      <td class="w-[18.75%]">
                        <div
                          class="d-flex flex-column gap-2"
                          v-for="(item, index) in formValues.kustodian
                            .pengawasOperasionalData"
                          :key="index"
                        >
                          <p class="fs-8 m-0 mb-1 mt-1">
                            {{ item.department }}
                          </p>
                        </div>
                      </td>
                      <td class="w-[18.75%]">
                        <div
                          class="d-flex flex-column gap-2"
                          v-if="
                            Array.isArray(
                              formValues.kustodian.pengawasOperasionalData,
                            ) && status === statusIMKPEnum.UNDER_REVIEW
                          "
                        >
                          <input
                            v-for="(item, index) in formValues.kustodian
                              .pengawasOperasionalData"
                            :key="index"
                            type="text"
                            class="form-control fs-8"
                            :class="{
                              'is-invalid':
                                formValidasi.pengawasOperasional[index].email,
                            }"
                            v-model="item.email"
                          />
                        </div>
                        <div
                          class="d-flex flex-column gap-2"
                          v-else
                          v-for="(item, index) in formValues.kustodian
                            .pengawasOperasionalData"
                          :key="index"
                        >
                          <p class="fs-8 m-0 mb-1 mt-1">
                            {{ item.email }}
                          </p>
                        </div>
                      </td>
                      <td class="w-[18.75%]">
                        <div
                          class="d-flex gap-2"
                          v-if="
                            Array.isArray(
                              formValues.kustodian.pengawasOperasionalData,
                            ) && status === statusIMKPEnum.UNDER_REVIEW
                          "
                        >
                          <div class="d-flex flex-column gap-2 w-100">
                            <div
                              v-for="(item, index) in formValues.kustodian
                                .pengawasOperasionalData"
                              :key="index"
                            >
                              <div class="d-flex gap-2">
                                <input
                                  type="text"
                                  class="form-control fs-8"
                                  v-model="item.contact"
                                  :class="{
                                    'is-invalid':
                                      formValidasi.pengawasOperasional[index]
                                        .contact,
                                  }"
                                />
                                <font-awesome-icon
                                  v-if="index === 0"
                                  @click="addRow('pengawasOperasional')"
                                  icon="fa-solid fa-circle-plus"
                                  style="
                                    color: #0d6efd;
                                    cursor: pointer;
                                    margin-top: 0.5rem;
                                  "
                                />
                                <font-awesome-icon
                                  v-else
                                  @click="
                                    deleteRow('pengawasOperasional', index)
                                  "
                                  icon="fa-solid fa-trash"
                                  style="
                                    color: #dc3545;
                                    cursor: pointer;
                                    margin-top: 0.5rem;
                                  "
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="d-flex flex-column gap-2"
                          v-else
                          v-for="(item, index) in formValues.kustodian
                            .pengawasOperasionalData"
                          :key="index"
                        >
                          <p class="fs-8 m-0 mb-1 mt-1">
                            {{ item.contact }}
                          </p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p class="fs-8 ms-2 m-0">Pengawas Teknik (Sipil)</p>
                      </td>
                      <td class="w-[18.75%]">
                        <div
                          class="d-flex gap-2"
                          v-if="
                            Array.isArray(
                              formValues.kustodian.pengawasTeknisSipilData,
                            ) && status === statusIMKPEnum.UNDER_REVIEW
                          "
                        >
                          <div class="d-flex flex-column gap-2 w-100">
                            <div
                              v-for="(_, index) in formValues.kustodian
                                .pengawasTeknisSipilData"
                              :key="index"
                            >
                              <v-autocomplete
                                variant="outlined"
                                density="compact"
                                hide-details
                                :items="
                                  optPengawasTeknikSipil[index]?.map(
                                    (item) => ({
                                      ...item,
                                      title: `${item.name} ${item.email} ${item.contact}`,
                                      value: item,
                                    }),
                                  )
                                "
                                item-title="title"
                                item-value="value"
                                color="#475569"
                                return-object
                                v-model="
                                  formValues.kustodian.pengawasTeknisSipil[
                                    index
                                  ]
                                "
                                @input="
                                  getPengawasTeknikSipil(
                                    $event.target.value,
                                    index,
                                  )
                                "
                                @update:modelValue="
                                  setInput(
                                    formValues.kustodian.pengawasTeknisSipil[
                                      index
                                    ],
                                    'pengawasTeknisSipil',
                                    index,
                                  )
                                "
                                :error="
                                  formValidasi.pengawasTeknikSipil[index].name
                                "
                              ></v-autocomplete>
                            </div>
                          </div>
                        </div>
                        <div
                          class="d-flex flex-column gap-2"
                          v-else
                          v-for="(item, index) in formValues.kustodian
                            .pengawasTeknisSipilData"
                          :key="index"
                        >
                          <p class="fs-8 m-0 mb-1 mt-1">
                            {{ item.name }}
                          </p>
                        </div>
                      </td>
                      <td class="w-[18.75%]">
                        <div
                          class="d-flex flex-column gap-2"
                          v-for="(item, index) in formValues.kustodian
                            .pengawasTeknisSipilData"
                          :key="index"
                        >
                          <p class="fs-8 m-0 mb-1 mt-1">
                            {{ item.department }}
                          </p>
                        </div>
                      </td>
                      <td class="w-[18.75%]">
                        <div
                          class="d-flex flex-column gap-2"
                          v-if="
                            Array.isArray(
                              formValues.kustodian.pengawasTeknisSipilData,
                            ) && status === statusIMKPEnum.UNDER_REVIEW
                          "
                        >
                          <input
                            v-for="(item, index) in formValues.kustodian
                              .pengawasTeknisSipilData"
                            :key="index"
                            type="text"
                            class="form-control fs-8"
                            :class="{
                              'is-invalid':
                                formValidasi.pengawasTeknikSipil[index].email,
                            }"
                            v-model="item.email"
                          />
                        </div>
                        <div
                          class="d-flex flex-column gap-2"
                          v-else
                          v-for="(item, index) in formValues.kustodian
                            .pengawasTeknisSipilData"
                          :key="index"
                        >
                          <p class="fs-8 m-0 mb-1 mt-1">
                            {{ item.email }}
                          </p>
                        </div>
                      </td>
                      <td class="w-[18.75%]">
                        <div
                          class="d-flex gap-2"
                          v-if="
                            Array.isArray(
                              formValues.kustodian.pengawasTeknisSipilData,
                            ) && status === statusIMKPEnum.UNDER_REVIEW
                          "
                        >
                          <div class="d-flex flex-column gap-2 w-100">
                            <div
                              v-for="(item, index) in formValues.kustodian
                                .pengawasTeknisSipilData"
                              :key="index"
                            >
                              <div class="d-flex gap-2">
                                <input
                                  type="text"
                                  class="form-control fs-8"
                                  v-model="item.contact"
                                  :class="{
                                    'is-invalid':
                                      formValidasi.pengawasTeknikSipil[index]
                                        .contact,
                                  }"
                                />
                                <font-awesome-icon
                                  v-if="index === 0"
                                  @click="addRow('pengawasTeknikSipil')"
                                  icon="fa-solid fa-circle-plus"
                                  style="
                                    color: #0d6efd;
                                    cursor: pointer;
                                    margin-top: 0.5rem;
                                  "
                                />
                                <font-awesome-icon
                                  v-else
                                  @click="
                                    deleteRow('pengawasTeknikSipil', index)
                                  "
                                  icon="fa-solid fa-trash"
                                  style="
                                    color: #dc3545;
                                    cursor: pointer;
                                    margin-top: 0.5rem;
                                  "
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="d-flex flex-column gap-2"
                          v-else
                          v-for="(item, index) in formValues.kustodian
                            .pengawasTeknisSipilData"
                          :key="index"
                        >
                          <p class="fs-8 m-0 mb-1 mt-1">
                            {{ item.contact }}
                          </p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p class="fs-8 ms-2 m-0">
                          Pengawas Teknis (Elektrikal)
                        </p>
                      </td>
                      <td class="w-[18.75%]">
                        <div
                          class="d-flex gap-2"
                          v-if="
                            Array.isArray(
                              formValues.kustodian.pengawasTeknisElektrikalData,
                            ) && status === statusIMKPEnum.UNDER_REVIEW
                          "
                        >
                          <div class="d-flex flex-column gap-2 w-100">
                            <div
                              v-for="(_, index) in formValues.kustodian
                                .pengawasTeknisElektrikalData"
                              :key="index"
                            >
                              <v-autocomplete
                                variant="outlined"
                                density="compact"
                                hide-details
                                :items="
                                  optPengawasTeknisElektrikal[index]?.map(
                                    (item) => ({
                                      ...item,
                                      title: `${item.name} ${item.email} ${item.contact}`,
                                      value: item,
                                    }),
                                  )
                                "
                                item-title="title"
                                item-value="value"
                                color="#475569"
                                return-object
                                v-model="
                                  formValues.kustodian.pengawasTeknisElektrikal[
                                    index
                                  ]
                                "
                                @input="
                                  getPengawasTeknisElektrikal(
                                    $event.target.value,
                                    index,
                                  )
                                "
                                @update:modelValue="
                                  setInput(
                                    formValues.kustodian
                                      .pengawasTeknisElektrikal[index],
                                    'pengawasTeknisElektrikal',
                                    index,
                                  )
                                "
                                :error="
                                  formValidasi.pengawasTeknikElektrikal[index]
                                    .name
                                "
                              ></v-autocomplete>
                            </div>
                          </div>
                        </div>
                        <div
                          class="d-flex flex-column gap-2"
                          v-else
                          v-for="(item, index) in formValues.kustodian
                            .pengawasTeknisElektrikalData"
                          :key="index"
                        >
                          <p class="fs-8 m-0 mb-1 mt-1">
                            {{ item.name }}
                          </p>
                        </div>
                      </td>
                      <td class="w-[18.75%]">
                        <div
                          class="d-flex flex-column gap-2"
                          v-for="(item, index) in formValues.kustodian
                            .pengawasTeknisElektrikalData"
                          :key="index"
                        >
                          <p class="fs-8 m-0 mb-1 mt-1">
                            {{ item.department }}
                          </p>
                        </div>
                      </td>
                      <td class="w-[18.75%]">
                        <div
                          class="d-flex flex-column gap-2"
                          v-if="
                            Array.isArray(
                              formValues.kustodian.pengawasTeknisElektrikalData,
                            ) && status === statusIMKPEnum.UNDER_REVIEW
                          "
                        >
                          <input
                            v-for="(item, index) in formValues.kustodian
                              .pengawasTeknisElektrikalData"
                            :key="index"
                            type="text"
                            class="form-control fs-8"
                            :class="{
                              'is-invalid':
                                formValidasi.pengawasTeknikElektrikal[index]
                                  .email,
                            }"
                            v-model="item.email"
                          />
                        </div>
                        <div
                          class="d-flex flex-column gap-2"
                          v-else
                          v-for="(item, index) in formValues.kustodian
                            .pengawasTeknisElektrikalData"
                          :key="index"
                        >
                          <p class="fs-8 m-0 mb-1 mt-1">
                            {{ item.email }}
                          </p>
                        </div>
                      </td>
                      <td class="w-[18.75%]">
                        <div
                          class="d-flex gap-2"
                          v-if="
                            Array.isArray(
                              formValues.kustodian.pengawasTeknisElektrikalData,
                            ) && status === statusIMKPEnum.UNDER_REVIEW
                          "
                        >
                          <div class="d-flex flex-column gap-2 w-100">
                            <div
                              v-for="(item, index) in formValues.kustodian
                                .pengawasTeknisElektrikalData"
                              :key="index"
                            >
                              <div class="d-flex gap-2">
                                <input
                                  type="text"
                                  class="form-control fs-8"
                                  v-model="item.contact"
                                  :class="{
                                    'is-invalid':
                                      formValidasi.pengawasTeknikElektrikal[
                                        index
                                      ].contact,
                                  }"
                                />
                                <font-awesome-icon
                                  v-if="index === 0"
                                  @click="addRow('pengawasTeknisElektrikal')"
                                  icon="fa-solid fa-circle-plus"
                                  style="
                                    color: #0d6efd;
                                    cursor: pointer;
                                    margin-top: 0.5rem;
                                  "
                                />
                                <font-awesome-icon
                                  v-else
                                  @click="
                                    deleteRow('pengawasTeknisElektrikal', index)
                                  "
                                  icon="fa-solid fa-trash"
                                  style="
                                    color: #dc3545;
                                    cursor: pointer;
                                    margin-top: 0.5rem;
                                  "
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="d-flex flex-column gap-2"
                          v-else
                          v-for="(item, index) in formValues.kustodian
                            .pengawasTeknisElektrikalData"
                          :key="index"
                        >
                          <p class="fs-8 m-0 mb-1 mt-1">
                            {{ item.contact }}
                          </p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p class="fs-8 ms-2 m-0">Pengawas Teknis (Mekanikal)</p>
                      </td>
                      <td class="w-[18.75%]">
                        <div
                          class="d-flex gap-2"
                          v-if="
                            Array.isArray(
                              formValues.kustodian.pengawasTeknisMekanikalData,
                            ) && status === statusIMKPEnum.UNDER_REVIEW
                          "
                        >
                          <div class="d-flex flex-column gap-2 w-100">
                            <div
                              v-for="(_, index) in formValues.kustodian
                                .pengawasTeknisMekanikalData"
                              :key="index"
                            >
                              <v-autocomplete
                                variant="outlined"
                                density="compact"
                                hide-details
                                :items="
                                  optPengawasTeknisMekanikal[index]?.map(
                                    (item) => ({
                                      ...item,
                                      title: `${item.name} ${item.email} ${item.contact}`,
                                      value: item,
                                    }),
                                  )
                                "
                                item-title="title"
                                item-value="value"
                                color="#475569"
                                return-object
                                v-model="
                                  formValues.kustodian.pengawasTeknisMekanikal[
                                    index
                                  ]
                                "
                                @input="
                                  getPengawasTeknisMekanikal(
                                    $event.target.value,
                                    index,
                                  )
                                "
                                @update:modelValue="
                                  setInput(
                                    formValues.kustodian
                                      .pengawasTeknisMekanikal[index],
                                    'pengawasTeknisMekanikal',
                                    index,
                                  )
                                "
                                :error="
                                  formValidasi.pengawasTeknikMekanikal[index]
                                    .name
                                "
                              ></v-autocomplete>
                            </div>
                          </div>
                        </div>
                        <div
                          class="d-flex flex-column gap-2"
                          v-else
                          v-for="(item, index) in formValues.kustodian
                            .pengawasTeknisMekanikalData"
                          :key="index"
                        >
                          <p class="fs-8 m-0 mb-1 mt-1">
                            {{ item.name }}
                          </p>
                        </div>
                      </td>
                      <td class="w-[18.75%]">
                        <div
                          class="d-flex flex-column gap-2"
                          v-for="(item, index) in formValues.kustodian
                            .pengawasTeknisMekanikalData"
                          :key="index"
                        >
                          <p class="fs-8 m-0 mb-1 mt-1">
                            {{ item.department }}
                          </p>
                        </div>
                      </td>
                      <td class="w-[18.75%]">
                        <div
                          class="d-flex flex-column gap-2"
                          v-if="
                            Array.isArray(
                              formValues.kustodian.pengawasTeknisMekanikalData,
                            ) && status === statusIMKPEnum.UNDER_REVIEW
                          "
                        >
                          <input
                            v-for="(item, index) in formValues.kustodian
                              .pengawasTeknisMekanikalData"
                            :key="index"
                            type="text"
                            class="form-control fs-8"
                            :class="{
                              'is-invalid':
                                formValidasi.pengawasTeknikMekanikal[index]
                                  .email,
                            }"
                            v-model="item.email"
                          />
                        </div>
                        <div
                          class="d-flex flex-column gap-2"
                          v-else
                          v-for="(item, index) in formValues.kustodian
                            .pengawasTeknisMekanikalData"
                          :key="index"
                        >
                          <p class="fs-8 m-0 mb-1 mt-1">
                            {{ item.email }}
                          </p>
                        </div>
                      </td>
                      <td class="w-[18.75%]">
                        <div
                          class="d-flex gap-2"
                          v-if="
                            Array.isArray(
                              formValues.kustodian.pengawasTeknisMekanikalData,
                            ) && status === statusIMKPEnum.UNDER_REVIEW
                          "
                        >
                          <div class="d-flex flex-column gap-2 w-100">
                            <div
                              v-for="(item, index) in formValues.kustodian
                                .pengawasTeknisMekanikalData"
                              :key="index"
                            >
                              <div class="d-flex gap-2">
                                <input
                                  type="text"
                                  class="form-control fs-8"
                                  v-model="item.contact"
                                  :class="{
                                    'is-invalid':
                                      formValidasi.pengawasTeknikMekanikal[
                                        index
                                      ].contact,
                                  }"
                                />
                                <font-awesome-icon
                                  v-if="index === 0"
                                  @click="addRow('pengawasTeknisMekanikal')"
                                  icon="fa-solid fa-circle-plus"
                                  style="
                                    color: #0d6efd;
                                    cursor: pointer;
                                    margin-top: 0.5rem;
                                  "
                                />
                                <font-awesome-icon
                                  v-else
                                  @click="
                                    deleteRow('pengawasTeknisMekanikal', index)
                                  "
                                  icon="fa-solid fa-trash"
                                  style="
                                    color: #dc3545;
                                    cursor: pointer;
                                    margin-top: 0.5rem;
                                  "
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="d-flex flex-column gap-2"
                          v-else
                          v-for="(item, index) in formValues.kustodian
                            .pengawasTeknisMekanikalData"
                          :key="index"
                        >
                          <p class="fs-8 m-0 mb-1 mt-1">
                            {{ item.contact }}
                          </p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p class="fs-8 ms-2 m-0">PIC OHS</p>
                      </td>
                      <td class="w-[18.75%]">
                        <div
                          class="d-flex gap-2"
                          v-if="
                            Array.isArray(formValues.kustodian.picOhsData) &&
                            status === statusIMKPEnum.UNDER_REVIEW
                          "
                        >
                          <div class="d-flex flex-column gap-2 w-100">
                            <div
                              v-for="(_, index) in formValues.kustodian
                                .picOhsData"
                              :key="index"
                            >
                              <v-autocomplete
                                variant="outlined"
                                density="compact"
                                hide-details
                                item-title="title"
                                item-value="value"
                                color="#475569"
                                return-object
                                :items="
                                  optPicOhs[index]?.map((item) => ({
                                    ...item,
                                    title: `${item.name} ${item.email} ${item.contact}`,
                                    value: item,
                                  }))
                                "
                                v-model="formValues.kustodian.picOhs[index]"
                                @input="getPicOhs($event.target.value, index)"
                                @update:modelValue="
                                  setInput(
                                    formValues.kustodian.picOhs[index],
                                    'picOhs',
                                    index,
                                  )
                                "
                                :error="formValidasi.picOhs[index].name"
                              ></v-autocomplete>
                            </div>
                          </div>
                        </div>
                        <div
                          class="d-flex flex-column gap-2"
                          v-else
                          v-for="(item, index) in formValues.kustodian
                            .picOhsData"
                          :key="index"
                        >
                          <p class="fs-8 m-0 mb-1 mt-1">
                            {{ item.name }}
                          </p>
                        </div>
                      </td>
                      <td class="w-[18.75%]">
                        <div
                          class="d-flex flex-column gap-2"
                          v-for="(item, index) in formValues.kustodian
                            .picOhsData"
                          :key="index"
                        >
                          <p class="fs-8 m-0 mb-1 mt-1">
                            {{ item.department }}
                          </p>
                        </div>
                      </td>
                      <td class="w-[18.75%]">
                        <div
                          class="d-flex flex-column gap-2"
                          v-if="
                            Array.isArray(formValues.kustodian.picOhsData) &&
                            status === statusIMKPEnum.UNDER_REVIEW
                          "
                        >
                          <input
                            v-for="(item, index) in formValues.kustodian
                              .picOhsData"
                            :key="index"
                            type="text"
                            class="form-control fs-8"
                            :class="{
                              'is-invalid': formValidasi.picOhs[index].email,
                            }"
                            v-model="item.email"
                          />
                        </div>
                        <div
                          class="d-flex flex-column gap-2"
                          v-else
                          v-for="(item, index) in formValues.kustodian
                            .picOhsData"
                          :key="index"
                        >
                          <p class="fs-8 m-0 mb-1 mt-1">
                            {{ item.email }}
                          </p>
                        </div>
                      </td>
                      <td class="w-[18.75%]">
                        <div
                          class="d-flex gap-2"
                          v-if="
                            Array.isArray(formValues.kustodian.picOhsData) &&
                            status === statusIMKPEnum.UNDER_REVIEW
                          "
                        >
                          <div class="d-flex flex-column gap-2 w-100">
                            <div
                              v-for="(item, index) in formValues.kustodian
                                .picOhsData"
                              :key="index"
                            >
                              <div class="d-flex gap-2">
                                <input
                                  type="text"
                                  class="form-control fs-8"
                                  v-model="item.contact"
                                  :class="{
                                    'is-invalid':
                                      formValidasi.picOhs[index].contact,
                                  }"
                                />
                                <font-awesome-icon
                                  v-if="index === 0"
                                  @click="addRow('picOhs')"
                                  icon="fa-solid fa-circle-plus"
                                  style="
                                    color: #0d6efd;
                                    cursor: pointer;
                                    margin-top: 0.5rem;
                                  "
                                />
                                <font-awesome-icon
                                  v-else
                                  @click="deleteRow('picOhs', index)"
                                  icon="fa-solid fa-trash"
                                  style="
                                    color: #dc3545;
                                    cursor: pointer;
                                    margin-top: 0.5rem;
                                  "
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="d-flex flex-column gap-2"
                          v-else
                          v-for="(item, index) in formValues.kustodian
                            .picOhsData"
                          :key="index"
                        >
                          <p class="fs-8 m-0 mb-1 mt-1">
                            {{ item.contact }}
                          </p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td style="background: #f8e3e5" colspan="5">
                        <p class="fs-8 fw-bold ms-2 m-0">
                          Historikal Statistik
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p class="fs-8 ms-2 m-0">
                          Insiden, Hazard Report, Inspeksi
                        </p>
                      </td>
                      <td colspan="4">
                        <div
                          class="d-flex gap-2"
                          v-if="
                            Array.isArray(
                              formValues.historikalStatistik.namaInsiden,
                            ) && status === statusIMKPEnum.UNDER_REVIEW
                          "
                        >
                          <div class="d-flex flex-column gap-2 w-100">
                            <div
                              v-for="(_, index) in formValues
                                .historikalStatistik.namaInsiden"
                              :key="index"
                            >
                              <div class="d-flex gap-2">
                                <div class="input-group">
                                  <span
                                    class="input-group-text fs-8"
                                    id="basic-addon3"
                                  >
                                    Departemen
                                  </span>
                                  <input
                                    type="text"
                                    class="form-control fs-8"
                                    aria-describedby="basic-addon3 basic-addon4"
                                    :class="{
                                      'is-invalid':
                                        formValidasi.namaInsiden[index],
                                    }"
                                    v-model="
                                      formValues.historikalStatistik
                                        .namaInsiden[index]
                                    "
                                  />
                                </div>
                                <font-awesome-icon
                                  v-if="index === 0"
                                  @click="addRow('namaInsiden')"
                                  icon="fa-solid fa-circle-plus"
                                  style="
                                    color: #0d6efd;
                                    cursor: pointer;
                                    margin-top: 0.5rem;
                                  "
                                />
                                <font-awesome-icon
                                  v-else
                                  @click="deleteRow('namaInsiden', index)"
                                  icon="fa-solid fa-trash"
                                  style="
                                    color: #dc3545;
                                    cursor: pointer;
                                    margin-top: 0.5rem;
                                  "
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="d-flex flex-column gap-2"
                          v-else
                          v-for="(item, index) in formValues.historikalStatistik
                            .namaInsiden"
                          :key="index"
                        >
                          <p class="fs-8 m-0 mb-1 mt-1">
                            {{ item ? "Departemen " + item : "-" }}
                          </p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p class="fs-8 ms-2 m-0">PIC untuk tindak lanjut NC</p>
                      </td>
                      <td colspan="4">
                        <div
                          class="d-flex gap-2"
                          v-if="
                            Array.isArray(
                              formValues.historikalStatistik.picNC,
                            ) && status === statusIMKPEnum.UNDER_REVIEW
                          "
                        >
                          <div class="d-flex flex-column gap-2 w-100">
                            <div
                              v-for="(_, index) in formValues
                                .historikalStatistik.picNC"
                              :key="index"
                            >
                              <div class="d-flex gap-2">
                                <v-autocomplete
                                  variant="outlined"
                                  density="compact"
                                  hide-details
                                  :items="
                                    optPicNC[index]?.map((item) => ({
                                      ...item,
                                      value: item,
                                    }))
                                  "
                                  item-title="name"
                                  item-value="value"
                                  color="#475569"
                                  return-object
                                  v-model="
                                    formValues.historikalStatistik.picNC[index]
                                  "
                                  @input="getPicNC($event.target.value, index)"
                                  :error="formValidasi.picNC[index]"
                                ></v-autocomplete>
                                <font-awesome-icon
                                  v-if="index === 0"
                                  @click="addRow('picNC')"
                                  icon="fa-solid fa-circle-plus"
                                  style="
                                    color: #0d6efd;
                                    cursor: pointer;
                                    margin-top: 0.5rem;
                                  "
                                />
                                <font-awesome-icon
                                  v-else
                                  @click="deleteRow('picNC', index)"
                                  icon="fa-solid fa-trash"
                                  style="
                                    color: #dc3545;
                                    cursor: pointer;
                                    margin-top: 0.5rem;
                                  "
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="d-flex flex-column gap-2"
                          v-else
                          v-for="(item, index) in formValues.historikalStatistik
                            .picNC"
                          :key="index"
                        >
                          <p class="fs-8 m-0 mb-1 mt-1">
                            {{ item }}
                          </p>
                        </div>
                      </td>
                    </tr>
                    <tr v-if="status === statusIMKPEnum.UNDER_REVIEW">
                      <td style="background: #f8e3e5" colspan="5">
                        <span class="text-xs font-normal italic text-red-700">
                          *Wajib di isi ketika dokumen pengajuan IMKP sudah
                          sesuai.
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                class="d-flex justify-content-end"
                v-if="
                  status === statusIMKPEnum.UNDER_REVIEW &&
                  $router.currentRoute.value.path.startsWith(
                    '/verifikasi-data-imkp',
                  )
                "
              >
                <button
                  :disabled="btnTolak"
                  :hidden="status !== statusIMKPEnum.UNDER_REVIEW"
                  class="btn btn-outline-danger me-2 w-25"
                  @click="clickTolak"
                >
                  Tolak
                </button>
                <button
                  :disabled="btnSetuju"
                  :hidden="status !== statusIMKPEnum.UNDER_REVIEW"
                  @click="modalConfirm('approved', 'submission')"
                  class="btn btn-danger w-25"
                >
                  Setujui
                </button>
              </div>
              <div
                class="d-flex justify-content-end"
                v-else-if="
                  status === statusIMKPEnum.IMKP_PUBLISHED &&
                  $router.currentRoute.value.path.startsWith(
                    '/amandemen-data-imkp',
                  )
                "
              >
                <button
                  class="btn btn-outline-danger me-2 w-25"
                  data-bs-toggle="modal"
                  data-bs-target="#reject-amandemen"
                >
                  Tolak
                </button>
                <button
                  @click="modalConfirm('approved', 'amandemen')"
                  class="btn btn-danger w-25"
                >
                  Setujui
                </button>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>

  <ModalComponent
    id="reject-imkp"
    title="Tolak Data IMKP"
    :modalType="3"
    :button="!btnSubmitTolak"
    @close-modal="closeModal"
    @click-submit="modalConfirm('rejected', 'submission')"
  >
    <div class="col-md-12">
      <div class="mb-1">
        <label class="form-label fs-8 fw-bold">Alasan</label>
      </div>
      <textarea
        class="form-control fs-8"
        rows="7"
        v-model="reason"
        placeholder="Masukkan alasan mengapa data ditolak"
      ></textarea>
    </div>
  </ModalComponent>

  <ModalComponent
    id="reject-amandemen"
    title="Tolak Data Amandemen IMKP"
    :modalType="3"
    :button="!btnSubmitTolakAmandemen"
    @close-modal="closeModal"
    @click-submit="modalConfirm('rejected', 'amandemen')"
  >
    <div class="col-md-12">
      <div class="mb-1">
        <label class="form-label fs-8 fw-bold">Alasan</label>
      </div>
      <textarea
        class="form-control fs-8"
        rows="7"
        v-model="reasonAmandemen"
        placeholder="Masukkan alasan mengapa data ditolak"
      ></textarea>
    </div>
  </ModalComponent>

  <ModalComponent :id="'error-message'" :modalType="2" :modalSize="'modal-lg'">
    <div style="max-height: 80vh; overflow-y: auto">
      <div v-html="errorMessage"></div>
    </div>
  </ModalComponent>
  <ModalComponent
    id="historyAmandemen-imkp"
    :modalType="2"
    :modalSize="'modal-xl'"
    @close-modal="closeModal"
  >
    <div class="mb-3">
      <h2 class="text-danger fw-bold">History Amandemen IMKP</h2>
      <p class="text-secondary">
        Daftar history amandemen IMKP yang dibuat kontraktor
      </p>
    </div>
    <div class="row d-flex mb-3">
      <div class="col-md-4">
        <div class="input-group">
          <span class="input-group-text" id="basic-addon1">
            <font-awesome-icon
              icon="fa-solid fa-magnifying-glass"
              style="color: #000000"
            />
          </span>
          <datepicker
            v-model="paramsHistoryAmandemen.keyword"
            class="form-control fs-8"
            format="dd MMMM yyyy"
            placeholder="Selesai pekerjaan"
          ></datepicker>
        </div>
      </div>
      <div class="col-md-4">
        <button
          type="button"
          @click="getHistory(false)"
          class="btn btn-danger w-100"
        >
          Cari Data
        </button>
      </div>
    </div>
    <div class="table-responsive">
      <table
        class="table table-striped mb-0"
        style="
          max-width: 100%;
          overflow-x: auto;
          font-family: 'Inter-Regular', serif;
        "
      >
        <thead
          style="
            font-family: 'Inter-Regular', serif;
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 24px;
            color: #28293d;
          "
        >
          <tr>
            <th style="background-color: #f8d7da" width="5%">No.</th>
            <th style="background-color: #f8d7da" width="20%">Judul Proyek</th>
            <th style="background-color: #f8d7da" width="15%">
              Selesai Pekerjaan
            </th>
            <th style="background-color: #f8d7da" width="15%">
              Selesai Pekerjaan Amandemen
            </th>
            <th style="background-color: #f8d7da" width="15%">
              Alasan Amandemen
            </th>
            <th style="background-color: #f8d7da" width="15%">Status</th>
            <th style="background-color: #f8d7da" width="15%">File</th>
          </tr>
        </thead>
        <tbody
          style="
            font-family: 'Inter-Regular';
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 24px;
            color: #28293d;
          "
        >
          <tr v-for="(item, index) in historyAmandemen" :key="item.id">
            <td class="no-style">{{ getIndexHistoryAmandemen(index) }}</td>
            <td>{{ item.judulProyek }}</td>
            <td>
              {{
                moment(new Date(item.tanggalSelesaiPekerjaan)).format(
                  "DD MMMM YYYY",
                )
              }}
            </td>
            <td>
              {{
                moment(new Date(item.tanggalSelesaiPekerjaanNew)).format(
                  "DD MMMM YYYY",
                )
              }}
            </td>
            <td>
              <p style="white-space: pre-line">
                {{ item.alasanAmandemen }}
              </p>
            </td>
            <td>
              <span
                class="badge"
                :class="{
                  'text-bg-success': item.statusAmandemen === 'approved',
                  'text-bg-danger': item.statusAmandemen === 'rejected',
                }"
              >
                {{
                  item.statusAmandemen === "approved"
                    ? "Diterima"
                    : item.statusAmandemen === "rejected"
                    ? "Ditolak"
                    : ""
                }} </span
              ><br />
              <p style="white-space: pre-line">
                {{ item.catatanAmandemen }}
              </p>
            </td>
            <td>
              <ul
                v-for="(file, index) in item.fileAmandemen"
                :key="index"
                class="p-0"
              >
                <li
                  @click="downloadFile(file)"
                  class="cursor-pointer link-danger link-offset-2 link-underline-opacity-0 link-underline-opacity-100-hover"
                >
                  {{ `File_${index + 1}.pdf` }}
                </li>
              </ul>
            </td>
          </tr>
          <tr v-if="historyAmandemen.length === 0">
            <td colspan="7" class="text-center">Tida Ada History Amandemen</td>
          </tr>
        </tbody>
      </table>
      <div
        class="d-flex align-items-center justify-content-end w-100"
        style="min-height: 5vh; background-color: #f8d7da"
      >
        <div class="w-100 d-flex align-items-center justify-content-end fs-6">
          <label for="size">Item Per Page</label>
          <select
            name="size"
            id="size"
            class="mx-2"
            v-model="paramsHistoryAmandemen.perPage"
            @change="getHistory(false)"
          >
            <option value="5" selected>5</option>
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
          <p id="stat_table" class="mb-1">
            {{
              (paramsHistoryAmandemen.currentPage + 1) *
                paramsHistoryAmandemen.perPage -
              (paramsHistoryAmandemen.perPage - 1)
            }}-{{
              (paramsHistoryAmandemen.currentPage + 1) *
                paramsHistoryAmandemen.perPage -
              (paramsHistoryAmandemen.perPage - 1) +
              (historyAmandemen.length - 1)
            }}
            of {{ paramsHistoryAmandemen.totalData }}
          </p>
          <button
            class="btn mr-2 mb-1"
            id="prev_page_table"
            @click="changeHistoryAmandemenPage(-1)"
          >
            &lt;
          </button>
          <button
            class="btn mb-1"
            id="next_page_table"
            @click="changeHistoryAmandemenPage(1)"
          >
            >
          </button>
        </div>
      </div>
    </div>
  </ModalComponent>
</template>
<script>
// import SidebarComponent from "@/components/SideBar.vue";
import axios from "axios";
import Swal from "sweetalert2";
import {
  API_BASE_URL,
  CMS_GET_DETAILKONTRAKTOR,
  CMS_GET_IMKP_HISTORY,
  CMS_GET_IMKP_TEMP,
  CMS_GET_KELENGKAPAN_SIO,
  CMS_IMKP_DETAIL,
  CMS_SET_IMKP_AMANDEMEN_OHS,
  CMS_SET_VERIFY,
  CMS_VIEW_IMAGE,
} from "@/constants";
import GlobalDataMixin from "@/GlobalDataMixin";
import {
  downloadFile,
  getSIOByIDContractor,
  showFile,
} from "@/utilities/globalFunction";
import { getSimper } from "@/utilities/ESBE";
import {
  validateEmail,
  validateNumber,
  validateObject,
  validateString,
} from "@/utilities/validateInput";
import ModalComponent from "@/components/ModalComponent.vue";
import UploadFileService from "@/utilities/upload-file";
import { levelEnum, statusIMKPEnum } from "@/utilities/enum";
import TableComponent from "./components/TableComponent.vue";
import Datepicker from "vuejs3-datepicker";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import { FormValidasiGeneral } from "./core/FormData";
import { formatSubLokasiDisplay } from "./core/subLokasiHelpers";

const url_imkp_detail = API_BASE_URL + CMS_IMKP_DETAIL;
const url_kontraktor = API_BASE_URL + CMS_GET_DETAILKONTRAKTOR;
const url_get_kelengkapan = API_BASE_URL + CMS_GET_KELENGKAPAN_SIO;
const url_verify = API_BASE_URL + CMS_SET_VERIFY;
const url_amandemen = API_BASE_URL + CMS_SET_IMKP_AMANDEMEN_OHS;
const url_imkp_temp = API_BASE_URL + CMS_GET_IMKP_TEMP;
const url_imkp_amandemen_history = API_BASE_URL + CMS_GET_IMKP_HISTORY;

export default {
  name: "VerifikasiDataImkpPage",
  mixins: [GlobalDataMixin],
  components: { DefaultLayout, ModalComponent, TableComponent, Datepicker },
  data() {
    return {
      isLoading: false,
      imkp: null,
      durasi: null,
      status: null,
      ttdPjoFile: null,
      formValidasi: {
        persyaratanKhusus: [],
        deptHeadKustodian: false,
        namaDepartemen: [],
        kepalaDepartemenKustodian: [
          { name: false, email: false, contact: false },
        ],
        pengawasOperasional: [{ name: false, email: false, contact: false }],
        pengawasTeknikSipil: [{ name: false, email: false, contact: false }],
        pengawasTeknikElektrikal: [
          { name: false, email: false, contact: false },
        ],
        pengawasTeknikMekanikal: [
          { name: false, email: false, contact: false },
        ],
        picOhs: [{ name: false, email: false, contact: false }],
        namaInsiden: [],
        picNC: [],
      },
      pjo: {},
      kontraktorName: null,
      jenis: null,
      nomorIzinUsaha: null,
      sioID: null,
      kontraktorID: null,
      formValues: {
        persyaratanKhusus: [],
        deptHeadKustodian: "",
        kustodian: {
          namaDepartemen: [null],
          kepalaDepartemen: [null],
          kepalaDepartemenData: [
            { name: null, department: null, email: null, contact: null },
          ],
          pengawasOperasional: [null],
          pengawasOperasionalData: [
            { name: null, department: null, email: null, contact: null },
          ],
          pengawasTeknisSipil: [null],
          pengawasTeknisSipilData: [
            { name: null, department: null, email: null, contact: null },
          ],
          pengawasTeknisElektrikal: [null],
          pengawasTeknisElektrikalData: [
            { name: null, department: null, email: null, contact: null },
          ],
          pengawasTeknisMekanikal: [null],
          pengawasTeknisMekanikalData: [
            { name: null, department: null, email: null, contact: null },
          ],
          picOhs: [null],
          picOhsData: [{ name: null, email: null, contact: null }],
        },
        historikalStatistik: {
          namaInsiden: [null],
          picNC: [null],
        },
      },
      formValidation: FormValidasiGeneral,
      optDeptHeadKustodian: [],
      optKepalaDepartemen: [],
      optPengawasOperasional: [],
      optPengawasTeknikSipil: [],
      optPengawasTeknisElektrikal: [],
      optPengawasTeknisMekanikal: [],
      optPicOhs: [],
      optPicNC: [],
      btnSetuju: true,
      btnTolak: false,
      btnSubmitTolak: false,
      btnSubmitTolakAmandemen: false,
      reason: "",
      reasonAmandemen: "",
      errorMessage: "",
      detailIzin: [],
      informasiProyek: [],
      kontraktorPelaksana: [],
      role: null,
      tempAmandemen: {},
      historyAmandemen: [],
      paramsHistoryAmandemen: {
        totalData: 0,
        totalPages: 0,
        currentPage: 0,
        perPage: 5,
        sortBy: null,
        sortDirection: null,
        keyword: null,
      },
    };
  },
  mounted() {
    this.role = this.userData.role.includes("ADMIN")
      ? levelEnum.ADMIN
      : this.userData.role.includes("OHS")
      ? levelEnum.OHS
      : this.userData.role.includes("reporter")
      ? levelEnum.REPORTER
      : this.userData.role === levelEnum.KONTRAKTOR
      ? levelEnum.KONTRAKTOR
      : levelEnum.ISAFE;

    if (this.role !== levelEnum.ADMIN && this.role !== levelEnum.OHS) {
      this.$router.push("/dashboard");
    }
    this.getIMKP(this.$route.params.id);
  },
  created() {
    this.uploadFileService = new UploadFileService(
      this.userData.token,
      this.userRole,
    );
  },
  watch: {
    formValues: {
      handler() {
        if (!this.isLoading) {
          this.handleValidasi();
        }
      },
      deep: true,
    },
    reason: {
      handler(newVal) {
        this.btnSubmitTolak = validateString(newVal);
      },
    },
    reasonAmandemen: {
      handler(newVal) {
        this.btnSubmitTolakAmandemen = validateString(newVal);
      },
    },
  },
  methods: {
    async getIMKP(id) {
      try {
        this.isLoading = true;

        if (
          this.$router.currentRoute.value.path.startsWith(
            "/amandemen-data-imkp",
          )
        ) {
          await this.getAmandemenTemp(id);
        }

        let params = {
          id: id,
        };

        const result = await axios.get(url_imkp_detail, {
          params: params,
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        });

        const res = result.data.data[0];

        if (res) {
          this.status = res.status;
          this.imkp = res;

          const mulai = res.tanggalMulaiPekerjaan
            ? new Date(res.tanggalMulaiPekerjaan)
            : null;
          const selesai = res.tanggalSelesaiPekerjaan
            ? new Date(res.tanggalSelesaiPekerjaan)
            : null;

          if (mulai && selesai && !isNaN(mulai) && !isNaN(selesai)) {
            const diffTime = selesai.getTime() - mulai.getTime();

            const diffDays = diffTime / (1000 * 60 * 60 * 24);

            this.durasi = Math.round(diffDays) + " Hari";
          } else {
            this.durasi = "-";
          }
          if (res.assets != null) {
            this.formValues.persyaratanKhusus = Object.entries(res.assets)
              .map(([key, value]) => ({
                ...value,
                key: key,
                name:
                  key === "assets_c_q1"
                    ? "Kontrak / PO / NOA / SI"
                    : key === "assets_c_q2"
                    ? "Daftar Dokumen Legal Perusahaan (IUJP/SIUP/IUJK) dan CoC"
                    : key === "assets_c_q3"
                    ? "Metode Kerja"
                    : key === "assets_c_q4"
                    ? "Identifikasi Bahaya dan Pengendalian Resiko"
                    : key === "assets_c_q5"
                    ? "Daftar pekerja dan lampiran bukti kompetensi, sertifikat dll"
                    : key === "assets_c_q6"
                    ? "Daftar sarana prasarana instalasi dan peralatan dan komisioning"
                    : key === "assets_c_q7"
                    ? "Standar Operasional Prosedur / Analisa Kerja Aman (AKA)"
                    : key === "assets_c_q8"
                    ? "HSE Plan"
                    : key === "assets_c_q9"
                    ? "Manajemen Perubahan (MOC)"
                    : key === "assets_c_q10"
                    ? "Water Management Plan"
                    : key === "assets_c_q11"
                    ? "Hydrocarbon Management Plan"
                    : key === "assets_c_q12"
                    ? "Emergency Response Plan"
                    : key === "assets_c_q13"
                    ? "Struktur Organisasi Proyek"
                    : null,
              }))
              .sort((a, b) => {
                const numA = parseInt(a.key.match(/\d+/)[0], 10);
                const numB = parseInt(b.key.match(/\d+/)[0], 10);
                return numA - numB;
              });
          }

          this.formValues.persyaratanKhusus.forEach((data, index) => {
            this.formValidasi.persyaratanKhusus[index] = {
              key: data.key,
              required: false,
            };
          });

          // handle validasi
          this.formValues.kustodian.namaDepartemen = res.namaDepartemenKustodian
            ? JSON.parse(res.namaDepartemenKustodian)
            : [null];
          this.formValues.historikalStatistik.namaInsiden =
            res.historikalInsiden ? JSON.parse(res.historikalInsiden) : [null];

          if (res.status !== statusIMKPEnum.UNDER_REVIEW) {
            this.formValues.deptHeadKustodian = {
              name: res.deptHeadKustodianNama,
              jabatan: res.deptHeadKustodianJabatan,
              tanggal: res.deptHeadKustodianTanggal,
            };

            // ------------------
            if (res.namaKepalaDepartemenKustodian) {
              const deptKepalaDepartemen = JSON.parse(
                res.departmentKepalaDepartemenKustodian ?? '[""]',
              );
              const emailKepalaDepartemen = JSON.parse(
                res.emailKepalaDepartemenKustodian,
              );
              const contactKepalaDepartemen = JSON.parse(
                res.noTeleponKepalaDepartemenKustodian,
              );
              JSON.parse(res.namaKepalaDepartemenKustodian).forEach(
                (item, index) => {
                  this.formValues.kustodian.kepalaDepartemenData[index] = {
                    name: item,
                    department: deptKepalaDepartemen[index],
                    email: emailKepalaDepartemen[index],
                    contact: contactKepalaDepartemen[index],
                  };
                },
              );
            }

            // ------------------
            if (res.namaKustodianPengawasOperasional) {
              const deptPengawasOperasional = JSON.parse(
                res.departmentKustodianPengawasOperasional ?? '[""]',
              );
              const emailPengawasOperasional = JSON.parse(
                res.emailKustodianPengawasOperasional,
              );
              const contactPengawasOperasional = JSON.parse(
                res.noTeleponKustodianPengawasOperasional,
              );
              JSON.parse(res.namaKustodianPengawasOperasional).forEach(
                (item, index) => {
                  this.formValues.kustodian.pengawasOperasionalData[index] = {
                    name: item,
                    department: deptPengawasOperasional[index],
                    email: emailPengawasOperasional[index],
                    contact: contactPengawasOperasional[index],
                  };
                },
              );
            }

            // ------------------
            if (res.namaKustodianPengawasTeknisSipil) {
              const deptPengawasTeknikSipil = JSON.parse(
                res.departmentKustodianPengawasTeknisSipil ?? '[""]',
              );
              const emailPengawasTeknisSipil = JSON.parse(
                res.emailKustodianPengawasTeknisSipil,
              );
              const contactPengawasTeknisSipil = JSON.parse(
                res.noTeleponKustodianPengawasTeknisSipil,
              );
              JSON.parse(res.namaKustodianPengawasTeknisSipil).forEach(
                (item, index) => {
                  this.formValues.kustodian.pengawasTeknisSipilData[index] = {
                    name: item,
                    department: deptPengawasTeknikSipil[index],
                    email: emailPengawasTeknisSipil[index],
                    contact: contactPengawasTeknisSipil[index],
                  };
                },
              );
            }

            // ------------------
            if (res.namaKustodianPengawasElektrikal) {
              const deptPengawasElektrikal = JSON.parse(
                res.departmentKustodianPengawasElektrikal ?? '[""]',
              );
              const emailPengawasElektrikal = JSON.parse(
                res.emailKustodianPengawasElektrikal,
              );
              const contactPengawasElektrikal = JSON.parse(
                res.noTeleponKustodianPengawasElektrikal,
              );
              JSON.parse(res.namaKustodianPengawasElektrikal).forEach(
                (item, index) => {
                  this.formValues.kustodian.pengawasTeknisElektrikalData[
                    index
                  ] = {
                    name: item,
                    department: deptPengawasElektrikal[index],
                    email: emailPengawasElektrikal[index],
                    contact: contactPengawasElektrikal[index],
                  };
                },
              );
            }

            // ------------------
            if (res.namaKustodianPengawasMekanikal) {
              const deptPengawasMekanikal = JSON.parse(
                res.departmentKustodianPengawasMekanikal ?? '[""]',
              );
              const emailPengawasMekanikal = JSON.parse(
                res.emailKustodianPengawasMekanikal,
              );
              const contactPengawasMekanikal = JSON.parse(
                res.noTeleponKustodianPengawasMekanikal,
              );
              JSON.parse(res.namaKustodianPengawasMekanikal).forEach(
                (item, index) => {
                  this.formValues.kustodian.pengawasTeknisMekanikalData[index] =
                    {
                      name: item,
                      department: deptPengawasMekanikal[index],
                      email: emailPengawasMekanikal[index],
                      contact: contactPengawasMekanikal[index],
                    };
                },
              );
            }

            // ------------------
            if (res.namaKustodianPicOhs) {
              const emailPicOhs = JSON.parse(res.emailKustodianPicOhs);
              const contactPicOhs = JSON.parse(res.noTeleponKustodianPicOhs);
              JSON.parse(res.namaKustodianPicOhs).forEach((item, index) => {
                this.formValues.kustodian.picOhsData[index] = {
                  name: item,
                  email: emailPicOhs[index],
                  contact: contactPicOhs[index],
                };
              });
            }

            this.formValues.historikalStatistik.picNC =
              res.historikalPicTindakLanjut
                ? JSON.parse(res.historikalPicTindakLanjut)
                : [null];
          }
          const sio = await getSIOByIDContractor(res.idKontraktor);
          this.sioID = sio.data.id;
          this.kontraktorID = res.idKontraktor;

          this.getKontraktor(res.idKontraktor);
          await this.getKelengkapan(this.sioID, sio);
          if (this.status === statusIMKPEnum.UNDER_REVIEW) {
            const kepalaDepartemen = [],
              pengawasOperasional = [],
              pengawasTeknisSipil = [],
              pengawasTeknisElektrikal = [],
              pengawasTeknisMekanikal = [],
              picOhs = [];

            if (res.namaDepartemenKustodian) {
              const departemen = JSON.parse(
                res.departmentKepalaDepartemenKustodian,
              );
              const email = JSON.parse(res.emailKepalaDepartemenKustodian);
              const contact = JSON.parse(
                res.noTeleponKepalaDepartemenKustodian,
              );
              JSON.parse(res.namaKepalaDepartemenKustodian).forEach(
                (item, index) => {
                  kepalaDepartemen[index] = {
                    name: item,
                    department: departemen[index],
                    email: email[index],
                    contact: contact[index],
                  };
                },
              );
            }
            if (res.namaKustodianPengawasOperasional) {
              const departemen = JSON.parse(
                res.departmentKustodianPengawasOperasional,
              );
              const email = JSON.parse(res.emailKustodianPengawasOperasional);
              const contact = JSON.parse(
                res.noTeleponKustodianPengawasOperasional,
              );
              JSON.parse(res.namaKustodianPengawasOperasional).forEach(
                (item, index) => {
                  pengawasOperasional[index] = {
                    name: item,
                    department: departemen[index],
                    email: email[index],
                    contact: contact[index],
                  };
                },
              );
            }
            if (res.namaKustodianPengawasTeknisSipil) {
              const departemen = JSON.parse(
                res.departmentKustodianPengawasTeknisSipil,
              );
              const email = JSON.parse(res.emailKustodianPengawasTeknisSipil);
              const contact = JSON.parse(
                res.noTeleponKustodianPengawasTeknisSipil,
              );
              JSON.parse(res.namaKustodianPengawasTeknisSipil).forEach(
                (item, index) => {
                  pengawasTeknisSipil[index] = {
                    name: item,
                    department: departemen[index],
                    email: email[index],
                    contact: contact[index],
                  };
                },
              );
            }
            if (res.namaKustodianPengawasElektrikal) {
              const departemen = JSON.parse(
                res.departmentKustodianPengawasElektrikal,
              );
              const email = JSON.parse(res.emailKustodianPengawasElektrikal);
              const contact = JSON.parse(
                res.noTeleponKustodianPengawasElektrikal,
              );
              JSON.parse(res.namaKustodianPengawasElektrikal).forEach(
                (item, index) => {
                  pengawasTeknisElektrikal[index] = {
                    name: item,
                    department: departemen[index],
                    email: email[index],
                    contact: contact[index],
                  };
                },
              );
            }
            if (res.namaKustodianPengawasMekanikal) {
              const departemen = JSON.parse(
                res.departmentKustodianPengawasMekanikal,
              );
              const email = JSON.parse(res.emailKustodianPengawasMekanikal);
              const contact = JSON.parse(
                res.noTeleponKustodianPengawasMekanikal,
              );
              JSON.parse(res.namaKustodianPengawasMekanikal).forEach(
                (item, index) => {
                  pengawasTeknisMekanikal[index] = {
                    name: item,
                    department: departemen[index],
                    email: email[index],
                    contact: contact[index],
                  };
                },
              );
            }
            if (res.namaKustodianPicOhs) {
              const email = JSON.parse(res.emailKustodianPicOhs);
              const contact = JSON.parse(res.noTeleponKustodianPicOhs);
              JSON.parse(res.namaKustodianPicOhs).forEach((item, index) => {
                picOhs[index] = {
                  name: item,
                  email: email[index],
                  contact: contact[index],
                };
              });
            }

            this.setListOptionFirstLoadPage(
              res.deptHeadKustodianNama,
              kepalaDepartemen,
              pengawasOperasional,
              pengawasTeknisSipil,
              pengawasTeknisElektrikal,
              pengawasTeknisMekanikal,
              picOhs,
              JSON.parse(res.historikalPicTindakLanjut),
            );
          }
        }
      } catch (error) {
        this.isLoading = false;
        console.log("error => ", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan saat mencari data detail IMKP!",
        });
      } finally {
        this.isLoading = false;
      }
    },
    async getAmandemenTemp(id) {
      try {
        const temp = await axios.get(url_imkp_temp, {
          params: { imkpId: id },
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        });

        const data = temp.data?.data;
        if (!Array.isArray(data) || data.length === 0) {
          this.tempAmandemen = {};
          Swal.fire({
            icon: "warning",
            title: "Data tidak ditemukan",
            text: "Data amandemen belum tersedia atau sudah ditindaklanjuti.",
          });
          return false;
        }

        this.tempAmandemen = data[0];
        return true;
      } catch (error) {
        this.tempAmandemen = {};
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan saat mencari data amandemen!",
        });
        return false;
      }
    },
    async getKelengkapan(id, sio) {
      try {
        const res = await axios.get(url_get_kelengkapan + id, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        });
        if (sio.data.downloadUrlPjo != null) {
          this.pjo.name = res.data.namaPjo;
          this.pjo.jabatan = res.data.jabatanPjo;
          this.pjo.ttd = res.data.ttdPjo;
        }
        if (res.data.ttdPjo !== "" && res.data.ttdPjo) {
          this.ttdPjoFile = API_BASE_URL + CMS_VIEW_IMAGE + res.data.ttdPjo;
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan saat mencari data kelengkapan!",
        });
      }
    },
    async getKontraktor(id) {
      try {
        const res = await axios.get(url_kontraktor + id, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        });

        if (res) {
          const kontaktor = res.data.detailKontraktor;

          this.kontraktorName = kontaktor.namaKontraktor;
          this.jenis = kontaktor.jenis;
          this.nomorIzinUsaha =
            kontaktor.jenis.toLocaleLowerCase() === "non inti"
              ? kontaktor.nib
              : kontaktor.iujp;
          if (!this.pjo.name) {
            this.pjo.name = kontaktor.namaPjo;
            this.pjo.jabatan = "Penanggung Jawab Operasional";
          }

          // Adjustment use component for table
          this.detailIzin = [
            {
              id: 1,
              label: "Kontraktor / Subkontraktor",
              value: this.kontraktorName,
            },
            {
              id: 2,
              label: "Nama Pemegang Izin",
              value: this.pjo.name,
            },
            {
              id: 3,
              label: "Lokasi Kerja",
              value: this.imkp.lokasiKerja,
            },
            {
              id: 4,
              label: "Sub Lokasi Kerja",
              value: formatSubLokasiDisplay(this.imkp.subLokasi),
            },
            {
              id: 5,
              label: "Keterangan Lokasi Proyek",
              value: this.imkp.keteranganLokasiKerja,
            },
            {
              id: 6,
              label: "Judul Proyek",
              value: this.imkp.judulProyek,
            },
            {
              id: 7,
              label: "Mulai Pekerjaan",
              value: this.imkp.tanggalMulaiPekerjaan
                ? moment(new Date(this.imkp.tanggalMulaiPekerjaan)).format(
                    "DD MMMM YYYY",
                  )
                : "-",
            },
            {
              id: 8,
              label: "Selesai Pekerjaan",
              value: this.imkp.tanggalSelesaiPekerjaan
                ? moment(new Date(this.imkp.tanggalSelesaiPekerjaan)).format(
                    "DD MMMM YYYY",
                  )
                : "-",
            },
            {
              id: 9,
              label: "Durasi Pekerjaan",
              value: this.durasi,
            },
            {
              id: 10,
              label: "Nomor Izin",
              value:
                this.imkp.nomorIzin ||
                `IMKP-${new Date().getFullYear()}-Generate by System`,
            },
          ];

          this.informasiProyek = [
            {
              id: 1,
              label: "Judul Proyek",
              value: this.imkp.judulProyek,
            },
            {
              id: 2,
              label: "Nomor Izin",
              value:
                this.imkp.nomorIzin ||
                `IMKP-${new Date().getFullYear()}-Generate by System`,
            },
            {
              id: 3,
              label: "Mulai Pekerjaan",
              value: this.imkp.tanggalMulaiPekerjaan
                ? moment(new Date(this.imkp.tanggalMulaiPekerjaan)).format(
                    "DD MMMM YYYY",
                  )
                : "-",
            },
            {
              id: 4,
              label: "Selesai Pekerjaan",
              value: this.imkp.tanggalSelesaiPekerjaan
                ? moment(new Date(this.imkp.tanggalSelesaiPekerjaan)).format(
                    "DD MMMM YYYY",
                  )
                : "-",
            },
            {
              id: 5,
              label: "Durasi Pekerjaan",
              value: this.durasi,
            },
            {
              id: 6,
              label: "Kontraktor / Subkontraktor",
              value: this.kontraktorName,
            },
            {
              id: 7,
              label: "Nama Direktur Utama",
              value: this.imkp.namaDirekturUtama,
            },
            {
              id: 8,
              label: "Jenis & Nomor Izin Usaha",
              value: this.jenis + " & " + this.nomorIzinUsaha,
            },
          ];

          this.kontraktorPelaksana = [
            {
              id: 1,
              label: "Nama PJO",
              name: this.pjo.name,
              email: this.imkp.emailPjo,
              phone: this.imkp.noTeleponPjo,
            },
            {
              id: 2,
              label: "Nama Pengawas Operasional",
              name: this.imkp.namaPengawasOperasional
                ? JSON.parse(this.imkp.namaPengawasOperasional)
                : [],
              email: this.imkp.emailPengawasOperasional
                ? JSON.parse(this.imkp.emailPengawasOperasional)
                : [],
              phone: this.imkp.noTeleponPengawasOperasional
                ? JSON.parse(this.imkp.noTeleponPengawasOperasional)
                : [],
            },
            {
              id: 3,
              label: "Nama Pengawas Teknis",
              name: this.imkp.namaPengawasTeknis
                ? JSON.parse(this.imkp.namaPengawasTeknis)
                : [],
              email: this.imkp.emailPengawasTeknis
                ? JSON.parse(this.imkp.emailPengawasTeknis)
                : [],
              phone: this.imkp.noTeleponPengawasTeknis
                ? JSON.parse(this.imkp.noTeleponPengawasTeknis)
                : [],
            },
            {
              id: 4,
              label: "Nama Tenaga Teknis Kompeten",
              name: this.imkp.namaTenagaTeknisKompeten
                ? JSON.parse(this.imkp.namaTenagaTeknisKompeten)
                : [],
              email: this.imkp.emailTenagaTeknisKompeten
                ? JSON.parse(this.imkp.emailTenagaTeknisKompeten)
                : [],
              phone: this.imkp.noTeleponTenagaTeknisKompeten
                ? JSON.parse(this.imkp.noTeleponTenagaTeknisKompeten)
                : [],
            },
            {
              id: 5,
              label: "Nama Hse Officer",
              name: this.imkp.namaHseOfficer
                ? JSON.parse(this.imkp.namaHseOfficer)
                : [],
              email: this.imkp.emailHseOfficer
                ? JSON.parse(this.imkp.emailHseOfficer)
                : [],
              phone: this.imkp.noTeleponHseOfficer
                ? JSON.parse(this.imkp.noTeleponHseOfficer)
                : [],
            },
          ];

          if (
            this.$router.currentRoute.value.path.startsWith(
              "/amandemen-data-imkp",
            ) &&
            Object.keys(this.tempAmandemen).length > 0
          ) {
            const selesaiAmandemenFormatted = this.tempAmandemen
              .tanggalSelesaiPekerjaan
              ? moment(
                  new Date(this.tempAmandemen.tanggalSelesaiPekerjaan),
                ).format("DD MMMM YYYY")
              : "-";

            const mulai = this.imkp.tanggalMulaiPekerjaan
              ? new Date(this.imkp.tanggalMulaiPekerjaan)
              : null;
            const selesai = this.tempAmandemen.tanggalSelesaiPekerjaan
              ? new Date(this.tempAmandemen.tanggalSelesaiPekerjaan)
              : null;

            let durasiAmandemen = "-";
            if (mulai && selesai && !isNaN(mulai) && !isNaN(selesai)) {
              const diffTime = selesai.getTime() - mulai.getTime();
              const diffDays = diffTime / (1000 * 60 * 60 * 24);
              durasiAmandemen = Math.round(diffDays) + " Hari";
            }

            this.detailIzin
              .filter((item) => item.id === 8)
              .forEach((item) => {
                Object.assign(item, {
                  highlight: true,
                  value: selesaiAmandemenFormatted,
                });
              });
            this.detailIzin
              .filter((item) => item.id === 9)
              .forEach((item) => {
                Object.assign(item, {
                  highlight: true,
                  value: durasiAmandemen,
                });
              });
            this.detailIzin = this.detailIzin.map((item) => {
              if (item.id === 9) {
                return { ...item, id: 11 };
              }
              if (item.id === 10) {
                return { ...item, id: 12 };
              }
              return item;
            });
            this.detailIzin.push(
              {
                id: 9,
                label:
                  "Dokumen Keterangan Persetujuan Perpanjangan Waktu Proyek",
                value: this.tempAmandemen.fileAmandemen
                  ? JSON.parse(this.tempAmandemen.fileAmandemen)
                  : [],
                file: true,
                title: "File Amandemen",
                highlight: true,
              },
              {
                id: 10,
                label: "Alasan Amandemen",
                value: this.tempAmandemen.alasanAmandemen,
                textArea: true,
                highlight: true,
              },
            );
            this.detailIzin.sort((a, b) => a.id - b.id);

            this.informasiProyek
              .filter((item) => item.id === 4)
              .forEach((item) => {
                Object.assign(item, {
                  highlight: true,
                  value: selesaiAmandemenFormatted,
                });
              });
            this.informasiProyek
              .filter((item) => item.id === 5)
              .forEach((item) => {
                Object.assign(item, {
                  highlight: true,
                  value: durasiAmandemen,
                });
              });
          }
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan saat mencari data kontraktor!",
        });
      }
    },
    async setListOptionFirstLoadPage(
      deptHead,
      headDepartemen,
      pengawasOperasional,
      pengawasTeknisSipil,
      pengawasTeknikElektrikal,
      pengawasTeknikMekanikal,
      picOhs,
      picNC,
    ) {
      try {
        if (deptHead) {
          const res = await getSimper(deptHead);
          if (res.simper?.length) {
            const simper = res.simper.find(
              (item) =>
                String(item.name).toLowerCase() ===
                String(deptHead).toLowerCase(),
            );
            this.formValues.deptHeadKustodian = simper
              ? {
                  ...simper,
                  title: `${simper.name ?? ""} ${simper.email ?? ""} ${
                    simper.contact ?? ""
                  }`.trim(),
                }
              : null;
            this.optDeptHeadKustodian = [simper];
          } else {
            this.formValues.deptHeadKustodian = null;
            this.optDeptHeadKustodian = [];
          }
        }
        if (Array.isArray(headDepartemen)) {
          for (const [index, item] of headDepartemen.entries()) {
            this.formValidasi.kepalaDepartemenKustodian[index] = {
              name: false,
              email: false,
              contact: false,
            };
            const res = await getSimper(item.name);
            if (res.simper?.length) {
              const simper = res.simper.find(
                (s) =>
                  String(s.name).toLowerCase() ===
                  String(item.name).toLowerCase(),
              );
              if (simper) {
                if (item.email) {
                  simper.email = item.email;
                }
                if (item.contact) {
                  simper.contact = item.contact;
                }
              }
              this.formValues.kustodian.kepalaDepartemen[index] = simper
                ? {
                    ...simper,
                    title: `${simper.name ?? ""} ${simper.email ?? ""} ${
                      simper.contact ?? ""
                    }`.trim(),
                  }
                : null;
              this.optKepalaDepartemen[index] = [simper];
              this.formValues.kustodian.kepalaDepartemenData[index] = item;
            } else {
              this.formValues.kustodian.kepalaDepartemen[index] = null;
              this.formValues.kustodian.kepalaDepartemenData[index] = item;
              this.optKepalaDepartemen[index] = [];
            }
          }
        }
        if (Array.isArray(pengawasOperasional)) {
          for (const [index, item] of pengawasOperasional.entries()) {
            this.formValidasi.pengawasOperasional[index] = {
              name: false,
              email: false,
              contact: false,
            };
            const res = await getSimper(item.name);
            if (res.simper?.length) {
              const simper = res.simper.find(
                (s) =>
                  String(s.name).toLowerCase() ===
                  String(item.name).toLowerCase(),
              );
              if (simper) {
                if (item.email) {
                  simper.email = item.email;
                }
                if (item.contact) {
                  simper.contact = item.contact;
                }
              }
              this.formValues.kustodian.pengawasOperasional[index] = simper
                ? {
                    ...simper,
                    title: `${simper.name ?? ""} ${simper.email ?? ""} ${
                      simper.contact ?? ""
                    }`.trim(),
                  }
                : null;
              this.optPengawasOperasional[index] = [simper];
              this.formValues.kustodian.pengawasOperasionalData[index] = item;
            } else {
              this.formValues.kustodian.pengawasOperasional[index] = null;
              this.formValues.kustodian.pengawasOperasionalData[index] = item;
              this.optPengawasOperasional[index] = [];
            }
            console.log(this.optPengawasOperasional[index]);
          }
        }
        if (Array.isArray(pengawasTeknisSipil)) {
          for (const [index, item] of pengawasTeknisSipil.entries()) {
            this.formValidasi.pengawasTeknikSipil[index] = {
              name: false,
              email: false,
              contact: false,
            };
            const res = await getSimper(item.name);
            if (res.simper?.length) {
              const simper = res.simper.find(
                (s) =>
                  String(s.name).toLowerCase() ===
                  String(item.name).toLowerCase(),
              );
              if (simper) {
                if (item.email) {
                  simper.email = item.email;
                }
                if (item.contact) {
                  simper.contact = item.contact;
                }
              }
              this.formValues.kustodian.pengawasTeknisSipil[index] = simper
                ? {
                    ...simper,
                    title: `${simper.name ?? ""} ${simper.email ?? ""} ${
                      simper.contact ?? ""
                    }`.trim(),
                  }
                : null;
              this.optPengawasTeknikSipil[index] = [simper];
              this.formValues.kustodian.pengawasTeknisSipilData[index] = item;
            } else {
              this.formValues.kustodian.pengawasTeknisSipil[index] = null;
              this.formValues.kustodian.pengawasTeknisSipilData[index] = item;
              this.optPengawasTeknikSipil[index] = [];
            }
          }
        }
        if (Array.isArray(pengawasTeknikElektrikal)) {
          for (const [index, item] of pengawasTeknikElektrikal.entries()) {
            this.formValidasi.pengawasTeknikElektrikal[index] = {
              name: false,
              email: false,
              contact: false,
            };
            const res = await getSimper(item.name);
            if (res.simper?.length) {
              const simper = res.simper.find(
                (s) =>
                  String(s.name).toLowerCase() ===
                  String(item.name).toLowerCase(),
              );
              if (simper) {
                if (item.email) {
                  simper.email = item.email;
                }
                if (item.contact) {
                  simper.contact = item.contact;
                }
              }
              this.formValues.kustodian.pengawasTeknisElektrikal[index] = simper
                ? {
                    ...simper,
                    title: `${simper.name ?? ""} ${simper.email ?? ""} ${
                      simper.contact ?? ""
                    }`.trim(),
                  }
                : null;
              this.optPengawasTeknisElektrikal[index] = [simper];
              this.formValues.kustodian.pengawasTeknisElektrikalData[index] =
                item;
            } else {
              this.formValues.kustodian.pengawasTeknisElektrikal[index] = null;
              this.formValues.kustodian.pengawasTeknisElektrikalData[index] =
                item;
              this.optPengawasTeknisElektrikal[index] = [];
            }
          }
        }
        if (Array.isArray(pengawasTeknikMekanikal)) {
          for (const [index, item] of pengawasTeknikMekanikal.entries()) {
            this.formValidasi.pengawasTeknikMekanikal[index] = {
              name: false,
              email: false,
              contact: false,
            };
            const res = await getSimper(item.name);
            if (res.simper?.length) {
              const simper = res.simper.find(
                (s) =>
                  String(s.name).toLowerCase() ===
                  String(item.name).toLowerCase(),
              );
              if (simper) {
                if (item.email) {
                  simper.email = item.email;
                }
                if (item.contact) {
                  simper.contact = item.contact;
                }
              }
              this.formValues.kustodian.pengawasTeknisMekanikal[index] = simper
                ? {
                    ...simper,
                    title: `${simper.name ?? ""} ${simper.email ?? ""} ${
                      simper.contact ?? ""
                    }`.trim(),
                  }
                : null;
              this.optPengawasTeknisMekanikal[index] = [simper];
              this.formValues.kustodian.pengawasTeknisMekanikalData[index] =
                item;
            } else {
              this.formValues.kustodian.pengawasTeknisMekanikal[index] = null;
              this.formValues.kustodian.pengawasTeknisMekanikalData[index] =
                item;
              this.optPengawasTeknisMekanikal[index] = [];
            }
          }
        }
        if (Array.isArray(picOhs)) {
          for (const [index, item] of picOhs.entries()) {
            const res = await getSimper(item.name);
            this.formValidasi.picOhs[index] = {
              name: false,
              email: false,
              contact: false,
            };
            if (res.simper?.length) {
              const simper = res.simper.find(
                (s) =>
                  String(s.name).toLowerCase() ===
                  String(item.name).toLowerCase(),
              );
              if (simper) {
                if (item.email) {
                  simper.email = item.email;
                }
                if (item.contact) {
                  simper.contact = item.contact;
                }
              }
              this.formValues.kustodian.picOhs[index] = simper
                ? {
                    ...simper,
                    title: `${simper.name ?? ""} ${simper.email ?? ""} ${
                      simper.contact ?? ""
                    }`.trim(),
                  }
                : null;
              this.optPicOhs[index] = [simper];
              this.formValues.kustodian.picOhsData[index] = item;
            } else {
              this.formValues.kustodian.picOhs[index] = null;
              this.formValues.kustodian.picOhsData[index] = item;
              this.optPicOhs[index] = [];
            }
          }
        }
        if (Array.isArray(picNC)) {
          for (const [index, item] of picNC.entries()) {
            const res = await getSimper(item);
            const itemName = typeof item === "string" ? item : item?.name;
            if (res.simper?.length) {
              const simper = res.simper.find(
                (s) =>
                  String(s.name).toLowerCase() ===
                  String(itemName ?? "").toLowerCase(),
              );
              if (simper && item && typeof item === "object") {
                if (item.email) {
                  simper.email = item.email;
                }
                if (item.contact) {
                  simper.contact = item.contact;
                }
              }
              this.formValues.historikalStatistik.picNC[index] = simper
                ? {
                    ...simper,
                    title: `${simper.name ?? ""} ${simper.email ?? ""} ${
                      simper.contact ?? ""
                    }`.trim(),
                  }
                : null;
              this.optPicNC[index] = [simper];
            } else {
              this.formValues.historikalStatistik.picNC[index] = null;
              this.optPicNC[index] = [];
            }
          }
        }
        const response = await getSimper();
        if (this.optDeptHeadKustodian.length === 0) {
          this.optDeptHeadKustodian = response.simper;
        }
        this.formValues.kustodian.kepalaDepartemen.forEach((_, index) => {
          if (!this.optKepalaDepartemen[index]?.length) {
            this.optKepalaDepartemen[index] = response.simper;
          }
        });
        this.formValues.kustodian.pengawasOperasional.forEach((_, index) => {
          if (!this.optPengawasOperasional[index]?.length) {
            this.optPengawasOperasional[index] = response.simper;
          }
        });
        this.formValues.kustodian.pengawasTeknisSipil.forEach((_, index) => {
          if (!this.optPengawasTeknikSipil[index]?.length) {
            this.optPengawasTeknikSipil[index] = response.simper;
          }
        });
        this.formValues.kustodian.pengawasTeknisElektrikal.forEach(
          (_, index) => {
            if (!this.optPengawasTeknisElektrikal[index]?.length) {
              this.optPengawasTeknisElektrikal[index] = response.simper;
            }
          },
        );
        this.formValues.kustodian.pengawasTeknisMekanikal.forEach(
          (_, index) => {
            if (!this.optPengawasTeknisMekanikal[index]?.length) {
              this.optPengawasTeknisMekanikal[index] = response.simper;
            }
          },
        );
        this.formValues.kustodian.picOhs.forEach((_, index) => {
          if (!this.optPicOhs[index]?.length) {
            this.optPicOhs[index] = response.simper;
          }
        });
        this.formValues.historikalStatistik.picNC.forEach((_, index) => {
          if (!this.optPicNC[index]?.length) {
            this.optPicNC[index] = response.simper;
          }
        });
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan saat mencari data simper!",
        });
      }
    },
    async getDeptHeadKustodian(keyword) {
      try {
        const res = await getSimper(keyword);
        this.optDeptHeadKustodian = res.simper;
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan saat mencari data dept head kustodian!",
        });
      }
    },
    async getKepalaDepartemen(keyword, index) {
      try {
        const res = await getSimper(keyword);
        this.optKepalaDepartemen[index] = res.simper;
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan saat mencari data kepala departemen!",
        });
      }
    },
    async getPengawasOperasional(keyword, index) {
      try {
        const res = await getSimper(keyword);
        this.optPengawasOperasional[index] = res.simper;
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan saat mencari data pengawas operasional!",
        });
      }
    },
    async getPengawasTeknikSipil(keyword, index) {
      try {
        const res = await getSimper(keyword);
        this.optPengawasTeknikSipil[index] = res.simper;
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan saat mencari data pengawas teknis sipil!",
        });
      }
    },
    async getPengawasTeknisElektrikal(keyword, index) {
      try {
        const res = await getSimper(keyword);
        this.optPengawasTeknisElektrikal[index] = res.simper;
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan saat mencari data pengawas teknis elektrikal!",
        });
      }
    },
    async getPengawasTeknisMekanikal(keyword, index) {
      try {
        const res = await getSimper(keyword);
        this.optPengawasTeknisMekanikal[index] = res.simper;
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan saat mencari data pengawas teknis mekanikal!",
        });
      }
    },
    async getPicOhs(keyword, index) {
      try {
        const res = await getSimper(keyword);
        this.optPicOhs[index] = res.simper;
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan saat mencari data pic ohs!",
        });
      }
    },
    async getPicNC(keyword, index) {
      try {
        const res = await getSimper(keyword);
        this.optPicNC[index] = res.simper;
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan saat mencari data pic nc!",
        });
      }
    },
    async doSubmitSubmissionImkp(action) {
      try {
        const assetsPersyaratanKhusus =
          this.formValues.persyaratanKhusus.reduce((acc, item) => {
            acc[item.key] = {
              file: Object.values(item.file),
              isVerified: item.isVerified,
              note: item.note ? item.note.trim() : null,
            };
            return acc;
          }, {});

        let bodyJson = {
          id: parseInt(this.$route.params.id),
          action: action,
          kontraktorId: this.kontraktorID,
          idSio: this.sioID,
          assets: JSON.stringify(assetsPersyaratanKhusus),
          deptHeadKustodianNama: this.formValues.deptHeadKustodian?.name,
          deptHeadKustodianJabatan: this.formValues.deptHeadKustodian?.jabatan,
          deptHeadKustodianTanggal: new Date(),
          deptHeadKustodianEmail: this.formValues.deptHeadKustodian?.email,
          namaDepartemenKustodian:
            this.formValues.kustodian.namaDepartemen.filter((item) => item)
              .length > 0
              ? JSON.stringify(this.formValues.kustodian.namaDepartemen)
              : null,
          namaKepalaDepartemenKustodian:
            this.formValues.kustodian.kepalaDepartemenData.filter(
              (item) => item.name,
            ).length > 0
              ? JSON.stringify(
                  this.formValues.kustodian.kepalaDepartemenData.map(
                    (item) => item.name,
                  ),
                )
              : null,
          departmentKepalaDepartemenKustodian:
            this.formValues.kustodian.kepalaDepartemenData.filter(
              (item) => item.department,
            ).length > 0
              ? JSON.stringify(
                  this.formValues.kustodian.kepalaDepartemenData.map(
                    (item) => item.department,
                  ),
                )
              : null,
          emailKepalaDepartemenKustodian:
            this.formValues.kustodian.kepalaDepartemenData.filter(
              (item) => item.email,
            ).length > 0
              ? JSON.stringify(
                  this.formValues.kustodian.kepalaDepartemenData.map(
                    (item) => item.email,
                  ),
                )
              : null,
          noTeleponKepalaDepartemenKustodian:
            this.formValues.kustodian.kepalaDepartemenData.filter(
              (item) => item.contact,
            ).length > 0
              ? JSON.stringify(
                  this.formValues.kustodian.kepalaDepartemenData.map(
                    (item) => item.contact,
                  ),
                )
              : null,
          namaKustodianPengawasOperasional:
            this.formValues.kustodian.pengawasOperasionalData.filter(
              (item) => item.name,
            ).length > 0
              ? JSON.stringify(
                  this.formValues.kustodian.pengawasOperasionalData.map(
                    (item) => item.name,
                  ),
                )
              : null,
          departmentKustodianPengawasOperasional:
            this.formValues.kustodian.pengawasOperasionalData.filter(
              (item) => item.department,
            ).length > 0
              ? JSON.stringify(
                  this.formValues.kustodian.pengawasOperasionalData.map(
                    (item) => item.department,
                  ),
                )
              : null,
          emailKustodianPengawasOperasional:
            this.formValues.kustodian.pengawasOperasionalData.filter(
              (item) => item.email,
            ).length > 0
              ? JSON.stringify(
                  this.formValues.kustodian.pengawasOperasionalData.map(
                    (item) => item.email,
                  ),
                )
              : null,
          noTeleponKustodianPengawasOperasional:
            this.formValues.kustodian.pengawasOperasionalData.filter(
              (item) => item.contact,
            ).length > 0
              ? JSON.stringify(
                  this.formValues.kustodian.pengawasOperasionalData.map(
                    (item) => item.contact,
                  ),
                )
              : null,
          namaKustodianPengawasTeknisSipil:
            this.formValues.kustodian.pengawasTeknisSipilData.filter(
              (item) => item.name,
            ).length > 0
              ? JSON.stringify(
                  this.formValues.kustodian.pengawasTeknisSipilData.map(
                    (item) => item.name,
                  ),
                )
              : null,
          departmentKustodianPengawasTeknisSipil:
            this.formValues.kustodian.pengawasTeknisSipilData.filter(
              (item) => item.department,
            ).length > 0
              ? JSON.stringify(
                  this.formValues.kustodian.pengawasTeknisSipilData.map(
                    (item) => item.department,
                  ),
                )
              : null,
          emailKustodianPengawasTeknisSipil:
            this.formValues.kustodian.pengawasTeknisSipilData.filter(
              (item) => item.email,
            ).length > 0
              ? JSON.stringify(
                  this.formValues.kustodian.pengawasTeknisSipilData.map(
                    (item) => item.email,
                  ),
                )
              : null,
          noTeleponKustodianPengawasTeknisSipil:
            this.formValues.kustodian.pengawasTeknisSipilData.filter(
              (item) => item.contact,
            ).length > 0
              ? JSON.stringify(
                  this.formValues.kustodian.pengawasTeknisSipilData.map(
                    (item) => item.contact,
                  ),
                )
              : null,
          namaKustodianPengawasElektrikal:
            this.formValues.kustodian.pengawasTeknisElektrikalData.filter(
              (item) => item.name,
            ).length > 0
              ? JSON.stringify(
                  this.formValues.kustodian.pengawasTeknisElektrikalData.map(
                    (item) => item.name,
                  ),
                )
              : null,
          departementKustodianPengawasElektrikal:
            this.formValues.kustodian.pengawasTeknisElektrikalData.filter(
              (item) => item.department,
            ).length > 0
              ? JSON.stringify(
                  this.formValues.kustodian.pengawasTeknisElektrikalData.map(
                    (item) => item.department,
                  ),
                )
              : null,
          emailKustodianPengawasElektrikal:
            this.formValues.kustodian.pengawasTeknisElektrikalData.filter(
              (item) => item.email,
            ).length > 0
              ? JSON.stringify(
                  this.formValues.kustodian.pengawasTeknisElektrikalData.map(
                    (item) => item.email,
                  ),
                )
              : null,
          noTeleponKustodianPengawasElektrikal:
            this.formValues.kustodian.pengawasTeknisElektrikalData.filter(
              (item) => item.contact,
            ).length > 0
              ? JSON.stringify(
                  this.formValues.kustodian.pengawasTeknisElektrikalData.map(
                    (item) => item.contact,
                  ),
                )
              : null,
          namaKustodianPengawasMekanikal:
            this.formValues.kustodian.pengawasTeknisMekanikalData.filter(
              (item) => item.name,
            ).length > 0
              ? JSON.stringify(
                  this.formValues.kustodian.pengawasTeknisMekanikalData.map(
                    (item) => item.name,
                  ),
                )
              : null,
          departementKustodianPengawasMekanikal:
            this.formValues.kustodian.pengawasTeknisMekanikalData.filter(
              (item) => item.department,
            ).length > 0
              ? JSON.stringify(
                  this.formValues.kustodian.pengawasTeknisMekanikalData.map(
                    (item) => item.department,
                  ),
                )
              : null,
          emailKustodianPengawasMekanikal:
            this.formValues.kustodian.pengawasTeknisMekanikalData.filter(
              (item) => item.email,
            ).length > 0
              ? JSON.stringify(
                  this.formValues.kustodian.pengawasTeknisMekanikalData.map(
                    (item) => item.email,
                  ),
                )
              : null,
          noTeleponKustodianPengawasMekanikal:
            this.formValues.kustodian.pengawasTeknisMekanikalData.filter(
              (item) => item.contact,
            ).length > 0
              ? JSON.stringify(
                  this.formValues.kustodian.pengawasTeknisMekanikalData.map(
                    (item) => item.contact,
                  ),
                )
              : null,
          namaKustodianPicOhs:
            this.formValues.kustodian.picOhsData.filter((item) => item.name)
              .length > 0
              ? JSON.stringify(
                  this.formValues.kustodian.picOhsData.map((item) => item.name),
                )
              : null,
          emailKustodianPicOhs:
            this.formValues.kustodian.picOhsData.filter((item) => item.email)
              .length > 0
              ? JSON.stringify(
                  this.formValues.kustodian.picOhsData.map(
                    (item) => item.email,
                  ),
                )
              : null,
          noTeleponKustodianPicOhs:
            this.formValues.kustodian.picOhsData.filter((item) => item.contact)
              .length > 0
              ? JSON.stringify(
                  this.formValues.kustodian.picOhsData.map(
                    (item) => item.contact,
                  ),
                )
              : null,
          historikalInsiden:
            this.formValues.historikalStatistik.namaInsiden.filter(
              (item) => item,
            ).length > 0
              ? JSON.stringify(this.formValues.historikalStatistik.namaInsiden)
              : null,
          historikalPicTindakLanjut:
            this.formValues.historikalStatistik.picNC.filter((item) =>
              validateObject(item),
            ).length > 0
              ? JSON.stringify(
                  this.formValues.historikalStatistik.picNC.map(
                    (item) => item.name,
                  ),
                )
              : null,
          alasanTolak: this.reason,
        };

        await axios.post(url_verify, bodyJson, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            Accept: "application/json",
          },
        });

        Swal.fire({
          title: action === "approved" ? "Setuju IMKP" : "Tolak IMKP",
          text: "IMKP berhasil ditindaklanjuti!",
          icon: "success",
          showConfirmButton: false,
          timer: 2000,
          showClass: {
            popup: "animate__animated animate__fadeInDown",
          },
          hideClass: {
            popup: "animate__animated animate__fadeOutUp",
          },
        }).then(() => {
          this.closeModal();
          this.$router.push({
            path: "/approval-imkp",
            query: this.$route.query,
          });
        });
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan!",
        });
      }
    },
    closeModal() {
      document.getElementById("btnClose-reject-imkp").click();
      document.getElementById("btnClose-reject-amandemen").click();

      this.reason = "";
      this.reasonAmandemen = "";
      this.paramsHistoryAmandemen.totalData = 0;
      this.paramsHistoryAmandemen.totalPages = 0;
      this.paramsHistoryAmandemen.currentPage = 0;
      this.paramsHistoryAmandemen.perPage = 5;
      this.paramsHistoryAmandemen.sortBy = null;
      this.paramsHistoryAmandemen.sortDirection = null;
      this.paramsHistoryAmandemen.keyword = null;
    },
    handleValidasi() {
      let setuju = true;

      this.formValues.persyaratanKhusus
        .filter((data) => data.file.length >= 1)
        .forEach((item) => {
          if (!item.isVerified) {
            if (item.note !== null) {
              this.formValidasi.persyaratanKhusus.find(
                (data) => data.key === item.key,
              ).required = !validateString(item.note);
            }
            setuju = setuju && false;
          } else if (item.isVerified) {
            this.formValidasi.persyaratanKhusus.find(
              (data) => data.key === item.key,
            ).required = false;
            setuju = setuju && true;
          }
        });

      if (this.formValues.deptHeadKustodian !== "") {
        this.formValidasi.deptHeadKustodian = !validateObject(
          this.formValues.deptHeadKustodian,
        );
        setuju = setuju && !this.formValidasi.deptHeadKustodian;
      } else {
        setuju = setuju && false;
      }

      if (this.formValues.kustodian.namaDepartemen.length >= 1) {
        this.formValues.kustodian.namaDepartemen.forEach((item, index) => {
          if (item !== null) {
            this.formValidasi.namaDepartemen[index] = !validateString(item);
            setuju = setuju && validateString(item);
          } else {
            setuju = setuju && false;
          }
        });
      } else {
        setuju = setuju && false;
      }

      if (
        Array.isArray(this.formValues.kustodian.kepalaDepartemen) &&
        this.formValues.kustodian.kepalaDepartemen.length >= 1
      ) {
        this.formValues.kustodian.kepalaDepartemenData.forEach(
          (item, index) => {
            if (item.name || item.email || item.contact) {
              this.formValidasi.kepalaDepartemenKustodian[index].name =
                !validateString(item.name);
              this.formValidasi.kepalaDepartemenKustodian[index].email =
                !validateEmail(item.email);
              this.formValidasi.kepalaDepartemenKustodian[index].contact =
                !validateNumber(item.contact);
              setuju = setuju && validateString(item.name);
              setuju = setuju && validateEmail(item.email);
              setuju = setuju && validateNumber(item.contact);
            } else {
              setuju = setuju && false;
            }
          },
        );
      } else {
        setuju = setuju && false;
      }

      if (
        Array.isArray(this.formValues.kustodian.pengawasOperasional) &&
        this.formValues.kustodian.pengawasOperasional.length >= 1
      ) {
        this.formValues.kustodian.pengawasOperasionalData.forEach(
          (item, index) => {
            if (item.name || item.email || item.contact) {
              this.formValidasi.pengawasOperasional[index].name =
                !validateString(item.name);
              this.formValidasi.pengawasOperasional[index].email =
                !validateEmail(item.email);
              this.formValidasi.pengawasOperasional[index].contact =
                !validateNumber(item.contact);
              setuju = setuju && validateString(item.name);
              setuju = setuju && validateEmail(item.email);
              setuju = setuju && validateNumber(item.contact);
            } else {
              setuju = setuju && false;
            }
          },
        );
      } else {
        setuju = setuju && false;
      }

      if (
        Array.isArray(this.formValues.kustodian.pengawasTeknisSipil) &&
        this.formValues.kustodian.pengawasTeknisSipil.length >= 1
      ) {
        this.formValues.kustodian.pengawasTeknisSipilData.forEach(
          (item, index) => {
            if (item.name !== null && item.name?.trim() !== "") {
              this.formValidasi.pengawasTeknikSipil[index].name =
                !validateString(item.name);

              setuju = setuju && validateString(item.name);
            } else {
              this.formValidasi.pengawasTeknikSipil[index].name = false;
            }

            if (item.email !== null && item.email?.trim() !== "") {
              this.formValidasi.pengawasTeknikSipil[index].email =
                !validateEmail(item.email);

              setuju = setuju && validateEmail(item.email);
            } else {
              this.formValidasi.pengawasTeknikSipil[index].email = false;
            }

            if (item.contact !== null && item.contact?.trim() !== "") {
              this.formValidasi.pengawasTeknikSipil[index].contact =
                !validateNumber(item.contact);

              setuju = setuju && validateNumber(item.contact);
            } else {
              this.formValidasi.pengawasTeknikSipil[index].contact = false;
            }
          },
        );
      }

      if (
        Array.isArray(this.formValues.kustodian.pengawasTeknisElektrikal) &&
        this.formValues.kustodian.pengawasTeknisElektrikal.length >= 1
      ) {
        this.formValues.kustodian.pengawasTeknisElektrikalData.forEach(
          (item, index) => {
            if (item.name !== null && item.name?.trim() !== "") {
              this.formValidasi.pengawasTeknikElektrikal[index].name =
                !validateString(item.name);

              setuju = setuju && validateString(item.name);
            } else {
              this.formValidasi.pengawasTeknikElektrikal[index].name = false;
            }

            if (item.email !== null && item.email?.trim() !== "") {
              this.formValidasi.pengawasTeknikElektrikal[index].email =
                !validateEmail(item.email);

              setuju = setuju && validateEmail(item.email);
            } else {
              this.formValidasi.pengawasTeknikElektrikal[index].email = false;
            }

            if (item.contact !== null && item.contact?.trim() !== "") {
              this.formValidasi.pengawasTeknikElektrikal[index].contact =
                !validateNumber(item.contact);

              setuju = setuju && validateNumber(item.contact);
            } else {
              this.formValidasi.pengawasTeknikElektrikal[index].contact = false;
            }
          },
        );
      }

      if (
        Array.isArray(this.formValues.kustodian.pengawasTeknisMekanikal) &&
        this.formValues.kustodian.pengawasTeknisMekanikal.length >= 1
      ) {
        this.formValues.kustodian.pengawasTeknisMekanikalData.forEach(
          (item, index) => {
            if (item.name !== null && item.name?.trim() !== "") {
              this.formValidasi.pengawasTeknikMekanikal[index].name =
                !validateString(item.name);

              setuju = setuju && validateString(item.name);
            } else {
              this.formValidasi.pengawasTeknikMekanikal[index].name = false;
            }

            if (item.email !== null && item.email?.trim() !== "") {
              this.formValidasi.pengawasTeknikMekanikal[index].email =
                !validateEmail(item.email);

              setuju = setuju && validateEmail(item.email);
            } else {
              this.formValidasi.pengawasTeknikMekanikal[index].email = false;
            }

            if (item.contact !== null && item.contact?.trim() !== "") {
              this.formValidasi.pengawasTeknikMekanikal[index].contact =
                !validateNumber(item.contact);

              setuju = setuju && validateNumber(item.contact);
            } else {
              this.formValidasi.pengawasTeknikMekanikal[index].contact = false;
            }
          },
        );
      }

      if (
        Array.isArray(this.formValues.kustodian.picOhs) &&
        this.formValues.kustodian.picOhs.length >= 1
      ) {
        this.formValues.kustodian.picOhsData.forEach((item, index) => {
          if (item.name || item.email || item.contact) {
            this.formValidasi.picOhs[index].name = !validateString(item.name);
            this.formValidasi.picOhs[index].email = !validateEmail(item.email);
            this.formValidasi.picOhs[index].contact = !validateNumber(
              item.contact,
            );
            setuju = setuju && validateString(item.name);
            setuju = setuju && validateEmail(item.email);
            setuju = setuju && validateNumber(item.contact);
          } else {
            setuju = setuju && false;
          }
        });
      } else {
        setuju = setuju && false;
      }

      if (this.formValues.historikalStatistik.namaInsiden.length >= 1) {
        this.formValues.historikalStatistik.namaInsiden.forEach(
          (item, index) => {
            if (item !== null) {
              this.formValidasi.namaInsiden[index] = !validateString(item);
              setuju = setuju && validateString(item);
            } else {
              setuju = setuju && false;
            }
          },
        );
      } else {
        setuju = setuju && false;
      }

      if (this.formValues.historikalStatistik.picNC.length >= 1) {
        this.formValues.historikalStatistik.picNC.forEach((item, index) => {
          if (item !== null) {
            this.formValidasi.picNC[index] = !validateObject(item);
            setuju = setuju && validateObject(item);
          } else {
            setuju = setuju && false;
          }
        });
      } else {
        setuju = setuju && false;
      }

      this.btnTolak = this.formValues.persyaratanKhusus
        .filter((item) => item.file.length >= 1)
        .every((data) => data.isVerified);

      this.btnSetuju = !setuju;
    },
    clickTolak() {
      let status = true,
        kolom = [];
      this.formValues.persyaratanKhusus
        .filter((dt) => dt.file.length >= 1)
        .forEach((item) => {
          if (!item.isVerified && !validateString(item.note)) {
            this.formValidasi.persyaratanKhusus.find(
              (data) => data.key === item.key,
            ).required = true;

            status = false;
            kolom.push("Catatan " + item.name);
          }
        });

      if (!status && kolom.length >= 1) {
        let message = "Formulir Anda memiliki kesalahan pada kolom berikut:\n";
        kolom.forEach(
          (field, index) => (message += `${index + 1}. ${field}\n`),
        );

        this.errorMessage = message.replace(/\n/g, "<br/>");
        let button = document.createElement("a");
        button.setAttribute("id", "errorMessageModal");
        button.setAttribute("data-bs-toggle", "modal");
        button.setAttribute("data-bs-target", "#error-message");
        document.body.appendChild(button);
        document.querySelector("#errorMessageModal").click();
        button.remove();
      } else {
        let button = document.createElement("a");
        button.setAttribute("id", "rejectImkpModal");
        button.setAttribute("data-bs-toggle", "modal");
        button.setAttribute("data-bs-target", "#reject-imkp");
        document.body.appendChild(button);
        document.querySelector("#rejectImkpModal").click();
        button.remove();
      }
    },
    modalConfirm(action, type) {
      let title = "";
      if (type === "submission") {
        title =
          action === "approved"
            ? "Setuju Pengajuan IMKP"
            : "Tolak Pengajuan IMKP";
      } else if (type === "amandemen") {
        title =
          action === "approved"
            ? "Setuju Amandemen IMKP"
            : "Tolak Amandemen IMKP";
      }

      Swal.fire({
        title: title,
        text: `Apakah anda yakin akan ${
          action === "approved" ? "menyetujui " : "menolak"
        } data IMKP ini`,
        icon: "warning",
        showCancelButton: true,
        showConfirmButton: true,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.isLoading = true;
          if (type === "submission") {
            this.doSubmitSubmissionImkp(action);
          } else if (type === "amandemen") {
            this.doSubmitAmandemenImkp(action);
          }
        }
      });
    },
    async doSubmitAmandemenImkp(action) {
      try {
        let bodyJson = {
          usecase: this.role,
          action: action,
          idIzinKontrak: parseInt(this.$route.params.id),
          catatanAmandemen: action !== "approved" ? this.reasonAmandemen : null,
        };

        await axios.post(url_amandemen, bodyJson, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            Accept: "application/json",
          },
        });

        Swal.fire({
          title:
            action === "approved"
              ? "Setuju Amandemen IMKP"
              : "Tolak Amandemen IMKP",
          text: "IMKP berhasil ditindaklanjuti!",
          icon: "success",
          showConfirmButton: false,
          timer: 2000,
          showClass: {
            popup: "animate__animated animate__fadeInDown",
          },
          hideClass: {
            popup: "animate__animated animate__fadeOutUp",
          },
        }).then(() => {
          this.closeModal();
          this.$router.push({
            path: "/approval-imkp",
            query: this.$route.query,
          });
        });
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan!",
        });
      }
    },
    async getHistory(modal) {
      try {
        let params = {
          usecase: "kontraktor",
          idImkp: parseInt(this.$route.params.id),
          search: this.paramsHistoryAmandemen.keyword
            ? moment(new Date(this.paramsHistoryAmandemen.keyword)).format(
                "YYYY-MM-DD",
              )
            : null,
          page: this.paramsHistoryAmandemen.currentPage,
          perPage: this.paramsHistoryAmandemen.perPage,
        };
        const result = await axios.get(url_imkp_amandemen_history, {
          params: params,
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        });
        this.paramsHistoryAmandemen.currentPage = result.data.page;
        this.paramsHistoryAmandemen.perPage = result.data.perPage;
        this.paramsHistoryAmandemen.totalData = result.data.totalRow;
        this.paramsHistoryAmandemen.totalPages = result.data.totalPage;

        this.historyAmandemen = result.data.data.map((item) => {
          item.fileAmandemen = item.fileAmandemen
            ? JSON.parse(item.fileAmandemen)
            : [];
          return item;
        });

        if (modal) {
          let button = document.createElement("a");
          button.setAttribute("id", "historyAmandemenModal");
          button.setAttribute("data-bs-toggle", "modal");
          button.setAttribute("data-bs-target", "#historyAmandemen-imkp");
          document.body.appendChild(button);
          document.querySelector("#historyAmandemenModal").click();
          button.remove();
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan!",
        });
      }
    },
    changeHistoryAmandemenPage(num) {
      let cp = this.paramsHistoryAmandemen.currentPage + num + 1;
      if (
        !(num == -1 && this.paramsHistoryAmandemen.currentPage == 0) &&
        cp * this.paramsHistoryAmandemen.perPage <=
          this.paramsHistoryAmandemen.totalData +
            (this.paramsHistoryAmandemen.perPage - 1)
      ) {
        this.paramsHistoryAmandemen.currentPage =
          this.paramsHistoryAmandemen.currentPage + num;
        this.getHistory(false);
      }
    },
    getIndexHistoryAmandemen(index) {
      return (
        index +
        this.paramsHistoryAmandemen.currentPage *
          this.paramsHistoryAmandemen.perPage +
        1
      );
    },
    addRow(row) {
      if (row === "namaDepartemen") {
        this.formValues.kustodian.namaDepartemen.push(null);
      }
      if (row === "kepalaDepartemenKustodian") {
        this.formValues.kustodian.kepalaDepartemen.push(null);
        this.formValues.kustodian.kepalaDepartemenData.push({
          name: null,
          department: null,
          email: null,
          contact: null,
        });
        this.formValidasi.kepalaDepartemenKustodian.push({
          name: false,
          email: false,
          contact: false,
        });

        this.getKepalaDepartemen(
          null,
          this.formValues.kustodian.kepalaDepartemen.length - 1,
        );
      }
      if (row === "pengawasOperasional") {
        this.formValues.kustodian.pengawasOperasional.push(null);
        this.formValues.kustodian.pengawasOperasionalData.push({
          name: null,
          department: null,
          email: null,
          contact: null,
        });
        this.formValidasi.pengawasOperasional.push({
          name: false,
          email: false,
          contact: false,
        });

        this.getPengawasOperasional(
          null,
          this.formValues.kustodian.pengawasOperasional.length - 1,
        );
      }
      if (row === "pengawasTeknikSipil") {
        this.formValues.kustodian.pengawasTeknisSipil.push(null);
        this.formValues.kustodian.pengawasTeknisSipilData.push({
          name: null,
          department: null,
          email: null,
          contact: null,
        });
        this.formValidasi.pengawasTeknikSipil.push({
          name: false,
          email: false,
          contact: false,
        });

        this.getPengawasTeknikSipil(
          null,
          this.formValues.kustodian.pengawasTeknisSipil.length - 1,
        );
      }
      if (row === "pengawasTeknisElektrikal") {
        this.formValues.kustodian.pengawasTeknisElektrikal.push(null);
        this.formValues.kustodian.pengawasTeknisElektrikalData.push({
          name: null,
          department: null,
          email: null,
          contact: null,
        });
        this.formValidasi.pengawasTeknikElektrikal.push({
          name: false,
          email: false,
          contact: false,
        });

        this.getPengawasTeknisElektrikal(
          null,
          this.formValues.kustodian.pengawasTeknisElektrikal.length - 1,
        );
      }
      if (row === "pengawasTeknisMekanikal") {
        this.formValues.kustodian.pengawasTeknisMekanikal.push(null);
        this.formValues.kustodian.pengawasTeknisMekanikalData.push({
          name: null,
          department: null,
          email: null,
          contact: null,
        });
        this.formValidasi.pengawasTeknikMekanikal.push({
          name: false,
          email: false,
          contact: false,
        });

        this.getPengawasTeknisMekanikal(
          null,
          this.formValues.kustodian.pengawasTeknisMekanikal.length - 1,
        );
      }
      if (row === "picOhs") {
        this.formValues.kustodian.picOhs.push(null);
        this.formValues.kustodian.picOhsData.push({
          name: null,
          email: null,
          contact: null,
        });
        this.formValidasi.picOhs.push({
          name: false,
          email: false,
          contact: false,
        });

        this.getPicOhs(null, this.formValues.kustodian.picOhs.length - 1);
      }
      if (row === "picNC") {
        this.formValues.historikalStatistik.picNC.push(null);

        this.getPicNC(
          null,
          this.formValues.historikalStatistik.picNC.length - 1,
        );
      }
      if (row === "namaInsiden") {
        this.formValues.historikalStatistik.namaInsiden.push(null);
      }
    },
    deleteRow(row, indexRemove) {
      if (row === "namaDepartemen") {
        this.formValues.kustodian.namaDepartemen.splice(indexRemove, 1);
        this.formValidasi.namaDepartemen.splice(indexRemove, 1);
      }
      if (row === "kepalaDepartemenKustodian") {
        this.formValues.kustodian.kepalaDepartemen.splice(indexRemove, 1);
        this.formValues.kustodian.kepalaDepartemenData.splice(indexRemove, 1);
        this.formValidasi.kepalaDepartemenKustodian.splice(indexRemove, 1);
      }
      if (row === "pengawasOperasional") {
        this.formValues.kustodian.pengawasOperasional.splice(indexRemove, 1);
        this.formValues.kustodian.pengawasOperasionalData.splice(
          indexRemove,
          1,
        );
        this.formValidasi.pengawasOperasional.splice(indexRemove, 1);
      }
      if (row === "pengawasTeknikSipil") {
        this.formValues.kustodian.pengawasTeknisSipil.splice(indexRemove, 1);
        this.formValues.kustodian.pengawasTeknisSipilData.splice(
          indexRemove,
          1,
        );
        this.formValidasi.pengawasTeknikSipil.splice(indexRemove, 1);
      }
      if (row === "pengawasTeknisElektrikal") {
        this.formValues.kustodian.pengawasTeknisElektrikal.splice(
          indexRemove,
          1,
        );
        this.formValues.kustodian.pengawasTeknisElektrikalData.splice(
          indexRemove,
          1,
        );
        this.formValidasi.pengawasTeknikElektrikal.splice(indexRemove, 1);
      }
      if (row === "pengawasTeknisMekanikal") {
        this.formValues.kustodian.pengawasTeknisMekanikal.splice(
          indexRemove,
          1,
        );
        this.formValues.kustodian.pengawasTeknisMekanikalData.splice(
          indexRemove,
          1,
        );
        this.formValidasi.pengawasTeknikMekanikal.splice(indexRemove, 1);
      }
      if (row === "picOhs") {
        this.formValues.kustodian.picOhs.splice(indexRemove, 1);
        this.formValues.kustodian.picOhsData.splice(indexRemove, 1);
        this.formValidasi.picOhs.splice(indexRemove, 1);
      }
      if (row === "picNC") {
        this.formValues.historikalStatistik.picNC.splice(indexRemove, 1);
        this.formValidasi.picNC.splice(indexRemove, 1);
      }
      if (row === "namaInsiden") {
        this.formValues.historikalStatistik.namaInsiden.splice(indexRemove, 1);
        this.formValidasi.namaInsiden.splice(indexRemove, 1);
      }
    },
    setInput(value, type, index) {
      if (type === "kepalaDepartemen") {
        this.formValues.kustodian.kepalaDepartemenData[index] = value
          ? {
              name: value.name,
              department: value.department,
              email: value.email,
              contact: value.contact,
            }
          : { name: null, department: null, email: null, contact: null };
      }
      if (type === "pengawasOperasional") {
        this.formValues.kustodian.pengawasOperasionalData[index] = value
          ? {
              name: value.name,
              department: value.department,
              email: value.email,
              contact: value.contact,
            }
          : { name: null, department: null, email: null, contact: null };
      }
      if (type === "pengawasTeknisSipil") {
        this.formValues.kustodian.pengawasTeknisSipilData[index] = value
          ? {
              name: value.name,
              department: value.department,
              email: value.email,
              contact: value.contact,
            }
          : { name: null, department: null, email: null, contact: null };
      }
      if (type === "pengawasTeknisElektrikal") {
        this.formValues.kustodian.pengawasTeknisElektrikalData[index] = value
          ? {
              name: value.name,
              department: value.department,
              email: value.email,
              contact: value.contact,
            }
          : { name: null, department: null, email: null, contact: null };
      }
      if (type === "pengawasTeknisMekanikal") {
        this.formValues.kustodian.pengawasTeknisMekanikalData[index] = value
          ? {
              name: value.name,
              department: value.department,
              email: value.email,
              contact: value.contact,
            }
          : { name: null, department: null, email: null, contact: null };
      }
      if (type === "picOhs") {
        this.formValues.kustodian.picOhsData[index] = value
          ? {
              name: value.name,
              email: value.email,
              contact: value.contact,
            }
          : { name: null, email: null, contact: null };
      }
    },
  },
};
</script>

<style scoped>
tr td:first-child:not(.no-style) {
  background: #f8e3e5;
}

tr td:first-child p {
  font-weight: 600;
}

.is-invalid-v-select {
  border: 1px solid #dc3545;
  border-radius: 5px;
}
</style>
